import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { CallClient, VideoStreamRenderer, LocalVideoStream, Features } from '@azure/communication-calling';
import { AzureCommunicationTokenCredential } from '@azure/communication-common';
import { Wand } from 'lucide-react';
import { useAtom } from 'jotai';
import { totalParticipantCountAtom } from '../../atoms/participantAtoms';
import '../../App.css';
import RenderDynamicView, { updateUiOnDemand, updateCount } from '../../RenderDynamicView';
import next from '../../assets/next.png';
import prev from '../../assets/prev.png';
import mute_incall from '../../assets/mute_incall.png';
import stop_video from '../../assets/stop_video.png';
import start_video from '../../assets/start_video.png';
import end_call from '../../assets/end_call.png';
import mute from '../../assets/mute.png';
import unmute from '../../assets/unmute.png';
import newmeeting from '../../assets/newmeeting.png';
import nextbtn from '../../assets/nextbtn.png';
import recording_start from '../../assets/recording_start.png';
import recording_pause from '../../assets/recording_pause.png';
import recording_resume from '../../assets/recording_resume.png';
import record_stop from '../../assets/record_stop.png';
import raise_hand_active from '../../assets/raise_hand_active.png';
import raise_hand_svg from '../../new_assets/raise_hand.svg';
import rise_hand from '../../assets/rise_hand.png';
import join_call from '../../assets/join_call.png';
import participant from '../../assets/participant.png';
import callbtn from '../../assets/callbtn.png';
import rejoin from '../../assets/rejoin.png';
import unmute_incall from '../../assets/unmute.svg';
import screen_shot from '../../assets/screen_shot.png';
import socket from '../../socket';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import toastQueue, { TOAST_CATEGORIES, lobbyToast, screenShareToast, recordingToast, participantToast, errorToast, successToast, infoToast, warningToast } from '../../utils/toastQueue';
import DisplayParticipantComponent from '../../components/DisplayParticipantComponent';
import DisplayScreenShot from '../../components/DisplayScreenShot';
import { getAcsToken, getAcsLoginToken } from '../../model/acsToken';
import LanguageDropdown from '../../components/LanguageDropdown';
import { useDeviceManager } from '../../hooks/useDeviceManager';
import { useRecordingTimer } from '../../hooks/useRecordingTimer';
import { takeScreenShot, getServerCallId, startRecording, startAndJoinCallApi, pauseRecording, ResumeRecording, stopRecording, fetchRecordingId, setRecordingId } from '../../model/util';
import { ReactInternetSpeedMeter } from 'react-internet-meter'
// import 'react-internet-speed-meter/dist/index.css'
import ACSChat from '../../components/LiveChatComponent/ACSChat';
// import PIPManager from './components/PIPComponent/PIPManager';
import HomeScreen from '../HomeScreenManager';
import Loader from '../../components/Loader';
import { displayLocalVideoStream, removeLocalVideoStream, getInitials } from "../../utils/videoStreamUtils"
import RecordingModal from '../../modals/RecordingModal';
import AdminListModal from '../../modals/AdminListModal';
import RecordingTransferModal from '../../modals/RecordingTransferModal';
import RequestedModal from '../../modals/RequestedModal';
import PermissionErrorModal from '../../modals/PermissionErrorModal';
import ScreenSharePermissionModal from '../../modals/ScreenSharePermissionModal';
import SettingsModal from '../../modals/SettingsModal';
import useScreenSharing from '../../hooks/useScreenSharing';
import ScreenSharingView from '../../components/ScreenSharingView';
import "../../componentStyle/ScreenSharingView.css";
import { getVideoClass, addScreenShareToParticipants, getActiveScreenShareStream, getClassName } from '../../utils/HelperFunction';
import lobbyNotificationSound from '../../assets/notification.mp3';
import PreJoinMeetingScreen from '../../components/Pre-join-meeting-screen';
import WaitingRoomScreen from '../../components/WaitingRoomScreen';
import AnimatedMicrophone from '../../components/AnimatedMicrophone';
import { NetworkDiagnosticModal } from '../../components/network-diagnostic-modal';
import OnVideoIcon from '../../new_assets/video_on.svg';
import OffVideoIcon from '../../new_assets/video_off.svg';
import OnMicIcon from '../../new_assets/mic_on.svg';
import offMicIcon from '../../new_assets/mic_off.svg';
import ArrowDownIcon from '../../new_assets/arrow_down.svg';
import WhiteArrowDownIcon from '../../new_assets/white_arrow_down.svg';
import ScreenShareIcon from '../../new_assets/screen_share.svg';
import participantIcon from '../../new_assets/participant.svg';
import handRaiseIcon from '../../new_assets/hand.svg';
import chatIcon from '../../new_assets/chat.svg';
import screenshotIcon from '../../new_assets/screenshot.svg';
import ellipsisYIcon from '../../new_assets/ellipsis_y.svg';
import bulbIcon from '../../new_assets/lightbulb.svg';
import recordingIcon from '../../new_assets/recording.svg';
import troubleshootIcon from '../../new_assets/troubleshoot.svg';
import PIPIcon from '../../new_assets/pip.svg';
import permissionIcon from '../../new_assets/permission.svg';
import reportIcon from '../../new_assets/issue.svg';
import copyIcon from '../../new_assets/copy.svg';
import usePictureInPicture from '../../components/PIP_Functionality/usePictureInPicture';
import settingsIcon from '../../new_assets/settings.svg';
import darkThemeIcon from '../../new_assets/dark.svg';
import lightThemeIcon from '../../new_assets/lightbulb.svg';
import { useTheme } from '../../contexts/ThemeContext';
import telephoneIcon from '../../new_assets/telephone.svg';
import stopRecordingIcon from '../../new_assets/stop_recording.svg';
import pauseRecordingIcon from '../../new_assets/pause_recording.svg';
import resumeRecordingIcon from '../../new_assets/resume_recording.svg';
import viewScreenShotIcon from '../../new_assets/view_screenshot_light.svg';
import VisualEffectsPanel from '../../components/VisualEffectsPanel';
import visualEffectsPresets from '../../utils/visualEffectsPresets';
import PinnedParticipantView from '../../components/PinnedParticipantView';

// const { sendMessageToServer } = require('./sendMessage');
const { addParticipantToRoom } = require('../../model/createRoomAcs');
const { receiveServerMessage, oneToOneMessage, updateUiOnAcceptCall, updateStatusOnUi, onloadCheckUserAlreadyJoined, userFullyJoined } = require('../../receiveMessage');



let isUnmannedUser = false;
let userAccessToken, userId, acsRoomId = '', acsusrt, callAgent, deviceManager = null, call = null, callId = '', displayName = '', senderSocketIdGlobal = '', senderUserIdGlobal = '';
let isParticipantRemoved = false, participantCountGlobal = 1;

// Pre-warm CallClient for faster initialization
let preWarmedCallClient = null;
let isPreWarmingInProgress = false;

let clientObjectArr = [], clientPagingArr = [];
const sanitizeParticipantData = (participant) => {
  if (!participant || typeof participant !== 'object') {
    return participant;
  }
  const {
    stream,
    renderer,
    videoRenderer,
    videoStreamRenderer,
    ...rest
  } = participant;
  return {
    ...rest,
    stream: null
  };
};
let pageIndex = 0, pageSize = 8;
let paggiStartIndex = 0, paggiLastIndex = pageSize;

let progressId = '', usertypeFromQuery = '', userIdFromOdrQueryParam = '', userIdOfSellerByuerFromOdr = '', isParticipantOpen = false, isScreenShotOpen = false, isLobbyOpen = false, isRightPanelOpenGlobal = false, isChatPannelOpen = false, isVisualEffectsOpen = false;
let tokenFromAzureLogin = '', serverCallId = '';
let uinfo = '', isUserJoinedToRoom = false, isModalFor = 'Recording', isOwnRemovedFromCall = false, callDurationInSec = 0, selectLanForRecording = '';
let intervalId = null, isAudioOngoingForLocal = true;
let ownerToken = '';
let micOption = false;
let videoOption = false;
let recordingStartBeforeJoining = false;
let screenSharerUserId = null;

const Home = React.memo(() => {
  const modalRefParticipant = useRef(null);
  const modalRefScreenShot = useRef(null);
  const modalChatRef = useRef(null);

  // Function to play lobby notification sound (moved inside component for access to state)
  const playLobbyNotificationSound = () => {
    try {
      const audio = new Audio(lobbyNotificationSound);
      audio.volume = 0.5; // Set volume to 50%
      audio.play().catch(error => {
        console.log('🔇 Could not play lobby notification sound:', error);
      });
    } catch (error) {
      console.log('🔇 Error creating audio for lobby notification:', error);
    }
  };
  const [displayRemoteParticipant, setDisplayRemoteParticipant] = useState([]);
  const [isShowPaggination, setIsShowPaggination] = useState(false);
  const [isAlreadyJoined, setIsAlreadyJoined] = useState(false);
  const [pagenumber, setPagenumber] = useState(0);
  const effectRan = useRef(false);
  const [localVideoStream, setLocalVideoStream] = useState(null);
  // const [localVideoStreamRenderer, setLocalVideoStreamRenderer] = useState(null);
  const [riseHandActiveStatus, setRiseHandActiveStatus] = useState(false);
  const [isRiseHandLoading, setIsRiseHandLoading] = useState(false);
  const riseHandTimeoutRef = useRef(null);
  const [lastRiseHandClick, setLastRiseHandClick] = useState(0);

  const [rejoinBtnShowStatus, setRejoinBtnShowStatus] = useState(true);
  const [isRecordingModal, setIsRecordingModal] = useState(false);
  const [adminListModel, setAdminListModel] = useState(false);
  const [recordingTransferModel, setRecordingTransferModel] = useState(false);
  const [isRequestedModalOpen, setIsRequestedModalOpen] = useState(false);
  const [isLanguageModal, setIsLanguageModal] = useState(false);
  const [isRightPanelOpen, setIsRightPanelOpen] = useState(false);
  const [isScreenSharePermissionModalOpen, setIsScreenSharePermissionModalOpen] = useState(false);
  const [permissionErrorModal, setPermissionErrorModal] = useState({
    isOpen: false,
    deviceType: null // 'camera' or 'microphone'
  });
  const [screenShareRequestData, setScreenShareRequestData] = useState(null);
  const [isNetworkDiagnosticModalOpen, setIsNetworkDiagnosticModalOpen] = useState(false);
  const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);
  const [isVideoOnGoing, setIsVideoOnGoing] = useState(true);
  const [isAudioOnGoing, setIsAudioOnGoing] = useState(true);
  const [isNextBtnActive, setIsNextBtnActive] = useState(true);
  const [recordingStatus, setRecordingStatus] = useState('initial');
  const [recordingInitiatorId, setRecordingInitiatorId] = useState(null);
  const [isRecordingConsentRequested, setIsRecordingConsentRequested] = useState(false);
  const [adminLink, setAdminLink] = useState('');
  const [sellerLink, setSellerLink] = useState('');
  const [participantCount, setParticipantCount] = useState(1);
  const [totalParticipantCount, setTotalParticipantCount] = useAtom(totalParticipantCountAtom);
  const [displayNameUi, setDisplayNameUi] = useState('');
  const [isWaitingForApproval, setIsWaitingForApproval] = useState(false);
  const [disconnectMessage, setDisconnectMessage] = useState('You left the meeting, Thank you for using our video call facility.');
  // const [displayLobby, setDisplayLobby] = useState([]);
  const [dynamicMessage, setDynamicMessage] = useState('');
  const [callDuration, setCallDuration] = useState('00:00:00');
  const localVideoContainerRef = useRef(null);
  const ToCaptureRef = useRef(null);
  const [totalUnreadMessageCount, setTotalUnreadMessageCount] = useState(0);
  const isCallCreator = useRef({});
  const [requestedAccessName, setRequestedAccessName] = useState("");
  const [requesterName, setRequesterName] = useState("");
  const [adminId, setAdminId] = useState("");
  const [openScreenShotMenuList, setOpenScreenShotMenuList] = useState(false);
  const visualEffectsPanelRef = useRef(null);
  const videoEffectsFeatureRef = useRef(null);
  const visualEffectsModuleRef = useRef(null);
  const activeVisualEffectRef = useRef(null);
  const [selectedVisualEffect, setSelectedVisualEffect] = useState('none');
  const [isApplyingVisualEffect, setIsApplyingVisualEffect] = useState(false);
  const [pendingVisualEffectId, setPendingVisualEffectId] = useState(null);
  const [isVisualEffectsPanelOpenState, setIsVisualEffectsPanelOpenState] = useState(false);
  // Dropdown states
  const [microphoneDropdownOpen, setMicrophoneDropdownOpen] = useState(false);
  const [cameraDropdownOpen, setCameraDropdownOpen] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [isScreenShared, setIsScreenShared] = useState(false);

  // Call initialization loader states
  const [isCallInitializing, setIsCallInitializing] = useState(false);
  const [callInitError, setCallInitError] = useState(null);
  const [callInitMessage, setCallInitMessage] = useState('');
  const callInitTimeoutRef = useRef(null);
  const [preJoinSettings, setPreJoinSettings] = useState({
    video: false,
    audio: false,
    selectedAudioDevice: null,
    selectedVideoDevice: null
  });

  const [selectedVideoCameraDevice, setSelectedVideoCameraDevice] = useState("");

  const [isMenuListOpen, setIsMenuListOpen] = useState(false);
  const [isThemeOpen, setIsThemeOpen] = useState(false);
  const { isDarkTheme, setLightTheme, setDarkTheme } = useTheme();
  const [isRejoining, setIsRejoining] = useState(false);
  const rejoiningRef = useRef(false); // Prevent multiple rejoin clicks
  const [isUserCallCreator, setIsUserCallCreator] = useState(false);
  const [pinnedParticipantId, setPinnedParticipantId] = useState(null);

  const visualEffectsOptions = useMemo(() => visualEffectsPresets, []);

  // Settings state
  const [appSettings, setAppSettings] = useState({
    voice: {
      noiseCancellation: true,
      advancedNoiseSuppression: false,
      echoCancellation: true,
      outputVolume: 100
    },
    video: {
      mirrorVideo: true,
      videoBrightness: 100
    },
    devices: {
      selectedMicrophone: 'default',
      selectedSpeaker: 'default'
    }
  });

  const [isEndCallDropdownOpen, setIsEndCallDropdownOpen] = useState(false);
  const [endCallModalIntent, setEndCallModalIntent] = useState(null);
  const clearEndCallModalIntent = useCallback(() => setEndCallModalIntent(null), []);

  // Handle settings changes
  const handleSettingsChange = async (newSettings) => {
    const oldSettings = appSettings;
    setAppSettings(newSettings);

    // Apply video effects
    applyVideoEffects(newSettings.video);

    // Check if audio settings changed
    if (oldSettings.voice.echoCancellation !== newSettings.voice.echoCancellation ||
      oldSettings.voice.noiseCancellation !== newSettings.voice.noiseCancellation ||
      oldSettings.voice.advancedNoiseSuppression !== newSettings.voice.advancedNoiseSuppression) {
      // Apply audio constraints if any audio setting changed
      await applyAudioConstraints();
    }

    // Store settings to localStorage
    localStorage.setItem('videoCallSettings', JSON.stringify(newSettings));
  };

  // Apply video effects (mirror and brightness)
  const applyVideoEffects = (videoSettings = appSettings.video) => {
    const mirrorVideo = videoSettings?.mirrorVideo ?? true;
    const videoBrightness = videoSettings?.videoBrightness ?? 100;

    // Apply to all video elements (local and remote)
    const videoElements = document.querySelectorAll('video');
    videoElements.forEach(video => {
      const remoteContainer = video.closest('.remoteUser');
      const isScreenShare = remoteContainer?.classList?.contains('remote-custom-screen-share');

      if (remoteContainer && !isScreenShare) {
        // Always mirror remote participant cameras to match local perspective
        video.style.transform = 'scaleX(-1)';
      } else if (isScreenShare) {
        // Ensure shared content stays readable
        video.style.transform = 'scaleX(1)';
      } else {
        // Local video honours the mirror setting
        video.style.transform = mirrorVideo ? 'scaleX(-1)' : 'scaleX(1)';
      }

      // Apply brightness to all video elements
      video.style.filter = `brightness(${videoBrightness}%)`;
    });
  };

  // Handle microphone change from settings
  const handleMicrophoneChange = async (device) => {
    if (!device || !call) return;

    try {
      // Select the new audio device
      selectAudioDevice(device);

      // If in a call, update the microphone
      if (call && deviceManager) {
        const audioDeviceInfo = await deviceManager.getMicrophones();
        const selectedMic = audioDeviceInfo.find(mic => mic.id === device.deviceId);

        if (selectedMic) {
          await call.mute();
          await deviceManager.selectMicrophone(selectedMic);
          if (isAudioOnGoing) {
            await call.unmute();
          }
        }
      }
    } catch (error) {
      console.error('Error changing microphone:', error);
    }
  };

  // Handle speaker change from settings
  const handleSpeakerChange = async (deviceId) => {
    try {
      // Set default audio output for all audio/video elements
      const mediaElements = document.querySelectorAll('audio, video');

      if ('setSinkId' in HTMLMediaElement.prototype) {
        for (const element of mediaElements) {
          try {
            await element.setSinkId(deviceId === 'default' ? '' : deviceId);
          } catch (err) {
            console.warn('Could not set audio output for element:', err);
          }
        }
      } else {
        console.warn('setSinkId is not supported in this browser');
      }
    } catch (error) {
      console.error('Error changing speaker:', error);
    }
  };

  // Apply audio constraints for noise/echo cancellation
  const applyAudioConstraints = async () => {
    try {
      // Get the current audio stream if available
      if (call && call.localAudioStream && call.localAudioStream.length > 0) {
        const audioStream = call.localAudioStream[0];
        let mediaStream;
        try {
          mediaStream = audioStream.getMediaStream();
        } catch (error) {
          // Handle permission error for audio stream
          console.error("Error getting audio media stream:", error);
          const errorMessage = error.message || error.toString() || '';
          if (errorMessage.includes('permission') ||
            errorMessage.includes('Permission') ||
            errorMessage.includes('AudioDeviceInfo') ||
            errorMessage.includes('MediaStream')) {
            setPermissionErrorModal({
              isOpen: true,
              deviceType: 'microphone'
            });
            return;
          }
          throw error;
        }

        if (mediaStream && mediaStream.getAudioTracks().length > 0) {
          const audioTrack = mediaStream.getAudioTracks()[0];

          // Apply constraints to the audio track
          const constraints = {
            echoCancellation: appSettings.voice.echoCancellation,
            noiseSuppression: appSettings.voice.noiseCancellation,
            autoGainControl: appSettings.voice.advancedNoiseSuppression
          };

          await audioTrack.applyConstraints(constraints);
          console.log('Audio constraints applied:', constraints);
        }
      } else if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // If not in call, apply constraints for future streams
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: {
            echoCancellation: appSettings.voice.echoCancellation,
            noiseSuppression: appSettings.voice.noiseCancellation,
            autoGainControl: appSettings.voice.advancedNoiseSuppression
          }
        });

        // Stop the stream as we just wanted to set constraints
        stream.getTracks().forEach(track => track.stop());
        console.log('Audio constraints configured for future streams');
      }
    } catch (error) {
      console.error('Error applying audio constraints:', error);
    }
  };

  const ensureEffectsLibrary = useCallback(async () => {
    if (visualEffectsModuleRef.current) {
      return visualEffectsModuleRef.current;
    }

    try {
      const module = await import('@azure/communication-calling-effects');
      const normalizedModule = module?.default ?? module;
      visualEffectsModuleRef.current = normalizedModule;
      return normalizedModule;
    } catch (error) {
      console.error('Failed to load visual effects helpers', error);
      throw error;
    }
  }, []);

  const ensureVideoEffectsFeature = useCallback(() => {
    if (!localVideoStream) {
      return null;
    }

    if (!videoEffectsFeatureRef.current) {
      videoEffectsFeatureRef.current = localVideoStream.feature(Features.VideoEffects);
    }

    return videoEffectsFeatureRef.current;
  }, [localVideoStream]);

  const disposeActiveEffect = useCallback(async () => {
    try {
      if (videoEffectsFeatureRef.current) {
        await videoEffectsFeatureRef.current.stopEffects();
      }
    } catch (error) {
      console.warn('Failed to stop visual effects', error);
    }

    if (activeVisualEffectRef.current && typeof activeVisualEffectRef.current.dispose === 'function') {
      try {
        await activeVisualEffectRef.current.dispose();
      } catch (error) {
        console.warn('Failed to dispose visual effect', error);
      }
    }

    activeVisualEffectRef.current = null;
  }, []);

  const resetVisualEffects = useCallback(async ({ skipStateReset = false } = {}) => {
    await disposeActiveEffect();
    setPendingVisualEffectId(null);
    setIsApplyingVisualEffect(false);
    if (!skipStateReset) {
      setSelectedVisualEffect('none');
    }
  }, [disposeActiveEffect]);

  const removeVisualEffect = useCallback(async ({ silent = false } = {}) => {
    if (selectedVisualEffect === 'none') {
      if (!silent) {
        infoToast.info('No visual effect is currently active.');
      }
      return;
    }

    await resetVisualEffects();

    if (!silent) {
      infoToast.info('Visual effects turned off.');
    }
  }, [resetVisualEffects, selectedVisualEffect]);

  const applyVisualEffect = useCallback(async (option, { force = false } = {}) => {
    if (!option) {
      return;
    }

    if (!force && option.id === selectedVisualEffect) {
      return;
    }

    if (!localVideoStream || !isVideoOnGoing) {
      infoToast.info('Turn on your camera to apply visual effects.');
      return;
    }

    const effectsFeature = ensureVideoEffectsFeature();

    if (!effectsFeature) {
      infoToast.info('Video stream is not ready yet. Please try again.');
      return;
    }

    setIsApplyingVisualEffect(true);
    setPendingVisualEffectId(option.id);

    try {
      const effectsModule = await ensureEffectsLibrary();

      let effectInstance;

      if (option.type === 'none') {
        await removeVisualEffect({ silent: true });
        return;
      }

      if (option.type === 'blur') {
        const BlurEffectCtor = effectsModule?.BackgroundBlurEffect;
        if (!BlurEffectCtor) {
          throw new Error('BackgroundBlurEffect constructor is unavailable.');
        }
        effectInstance = new BlurEffectCtor({
          blurAmount: option.blurAmount || 'medium'
        });
      } else if (option.type === 'replacement') {
        const ReplacementEffectCtor = effectsModule?.BackgroundReplacementEffect;
        if (!ReplacementEffectCtor) {
          throw new Error('BackgroundReplacementEffect constructor is unavailable.');
        }

        effectInstance = new ReplacementEffectCtor({
          backgroundImageUrl: option.imageUrl
        });
      } else {
        throw new Error(`Unsupported visual effect type: ${option.type}`);
      }

      const isSupported = await effectsFeature.isSupported(effectInstance);
      if (!isSupported) {
        effectInstance?.dispose?.();
        errorToast.error('This effect is not supported on your device.');
        return;
      }

      await disposeActiveEffect();

      activeVisualEffectRef.current = effectInstance;
      await effectsFeature.startEffects(effectInstance);
      setSelectedVisualEffect(option.id);
    } catch (error) {
      console.error('Failed to apply visual effect', error);
      errorToast.error('Could not apply the selected visual effect.');
      await disposeActiveEffect();
      setSelectedVisualEffect('none');
    } finally {
      setIsApplyingVisualEffect(false);
      setPendingVisualEffectId(null);
    }
  }, [disposeActiveEffect, ensureEffectsLibrary, ensureVideoEffectsFeature, isVideoOnGoing, localVideoStream, removeVisualEffect, selectedVisualEffect]);

  useEffect(() => {
    if (!localVideoStream) {
      videoEffectsFeatureRef.current = null;
      if (selectedVisualEffect !== 'none') {
        resetVisualEffects();
      }
      return;
    }

    const feature = localVideoStream.feature(Features.VideoEffects);
    videoEffectsFeatureRef.current = feature;

    const handleEffectsError = (error) => {
      console.error('Visual effects error', error);
      errorToast.error('Visual effect encountered an issue and was turned off.');
      resetVisualEffects();
    };

    feature.on('effectsError', handleEffectsError);

    return () => {
      feature.off('effectsError', handleEffectsError);
      if (videoEffectsFeatureRef.current === feature) {
        videoEffectsFeatureRef.current = null;
      }
    };
  }, [localVideoStream, resetVisualEffects, selectedVisualEffect]);

  useEffect(() => {
    if (!isVideoOnGoing && selectedVisualEffect !== 'none') {
      resetVisualEffects();
    }
  }, [isVideoOnGoing, resetVisualEffects, selectedVisualEffect]);
  // Device management using custom hook
  const {
    // Audio devices
    availableAudioDevices,
    selectedAudioDevice,
    audioPermissionGranted,
    audioError,
    isLoadingAudio,
    loadAudioDevices,
    selectAudioDevice,
    clearAudioError,

    // Video devices
    availableVideoDevices,
    selectedVideoDevice,
    videoPermissionGranted,
    videoError,
    isLoadingVideo,
    loadVideoDevices,
    selectVideoDevice,
    clearVideoError,

    // Combined functions
    loadAllDevices,
    resetDevices,
    handleDeviceChange
  } = useDeviceManager({
    autoInitialize: true,
    listenForChanges: true
  });

  // Recording timer using custom hook with synchronization
  const {
    isRunning: isTimerRunning,
    isPaused: isTimerPaused,
    displayTime: recordingTimer,
    start: startRecordingTimer,
    pause: pauseRecordingTimer,
    resume: resumeRecordingTimer,
    stop: stopRecordingTimer,
    getTimerState,
    syncWithExternalState,
    requestSync
  } = useRecordingTimer({
    onTimerUpdate: (timerState) => {
      // Emit timer update to server for synchronization
      if (socket && acsRoomId && isCallCreator.current[userId]) {
        socket.emit('BE-recording-timer-update', {
          acsRoomId,
          timerState,
          adminUserId: userId
        });
      }
    },
    onSyncRequest: () => {
      // Request timer sync from server
      if (socket && acsRoomId) {
        socket.emit('BE-recording-timer-sync-request', {
          acsRoomId,
          userId
        });
      }
    }
  });

  // Load settings from localStorage on mount
  useEffect(() => {
    const savedSettings = localStorage.getItem('videoCallSettings');
    if (savedSettings) {
      try {
        const parsed = JSON.parse(savedSettings);
        setAppSettings(parsed);
        // Apply video effects to any existing video elements
        setTimeout(() => {
          applyVideoEffects(parsed.video);
        }, 100);
      } catch (error) {
        console.error('Error loading saved settings:', error);
      }
    }
  }, []);

  // Apply video effects when video stream changes
  useEffect(() => {
    if (localVideoStream) {
      // Apply effects after a short delay to ensure video element is rendered
      setTimeout(() => {
        applyVideoEffects(appSettings.video);
      }, 200);
    }
  }, [localVideoStream, appSettings.video]);

  // Apply volume settings to all media elements
  useEffect(() => {
    const applyVolume = () => {
      const audioElements = document.querySelectorAll('audio, video');
      audioElements.forEach(element => {
        element.volume = appSettings.voice.outputVolume / 100;
      });
    };

    // Apply on mount and when settings change
    applyVolume();

    // Also apply when new elements are added
    const observer = new MutationObserver(() => {
      applyVolume();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return () => observer.disconnect();
  }, [appSettings.voice.outputVolume]);

  useEffect(() => {
    if (preJoinSettings && preJoinSettings.selectedAudioDevice && availableAudioDevices.length > 0) {
      const deviceExists = availableAudioDevices.some(device =>
        device.deviceId === preJoinSettings.selectedAudioDevice.deviceId
      );
      if (deviceExists) {
        selectAudioDevice(preJoinSettings.selectedAudioDevice);
      }
    }
  }, [preJoinSettings, preJoinSettings?.selectedAudioDevice, availableAudioDevices, selectAudioDevice]);

  useEffect(() => {
    if (preJoinSettings && preJoinSettings.selectedVideoDevice && availableVideoDevices.length > 0) {
      const deviceExists = availableVideoDevices.some(device =>
        device.deviceId === preJoinSettings.selectedVideoDevice.deviceId
      );
      if (deviceExists) {
        selectVideoDevice(preJoinSettings.selectedVideoDevice);
      }
    }
  }, [preJoinSettings, preJoinSettings?.selectedVideoDevice, availableVideoDevices, selectVideoDevice]);

  // Debug: Log when selected camera changes
  useEffect(() => {
    if (selectedVideoDevice) {
      console.log('📹 Selected camera changed to:', selectedVideoDevice.label || selectedVideoDevice.deviceId);
    } else {
      console.log('📹 No camera selected');
    }
  }, [selectedVideoDevice?.deviceId]);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (callInitTimeoutRef.current) {
        clearTimeout(callInitTimeoutRef.current);
      }
    };
  }, []);

  // Cleanup toast queues on unmount
  useEffect(() => {
    return () => {
      toastQueue.clearAll();
    };
  }, []);

  const {
    isScreenSharing,
    setIsScreenSharing,
    startScreenSharing,
    stopScreenSharing,
    isSomeoneScreenSharing,
    getCurrentScreenSharer,
    requestScreenSharePermission,
    handleScreenSharePermissionRequest,
    handleScreenSharePermissionResponse,
    forceStopScreenSharing,
    pendingScreenShareRequest
  } = useScreenSharing({
    call,
    acsRoomId,
    userId,
    socket,
    clientObjectArr,
    isUserCallCreator: isCallCreator.current[userId],
    displayName,
    renderScreenAfterScreenSharingStop: () => {
      // Add delay to ensure screen share is completely stopped
      setTimeout(() => {
        updateScreenShareView();

        // Also update the UI to ensure proper re-rendering
        setTimeout(() => {
          onloadDisplayPreviewOnLoad();

          // Additional check to ensure local video is properly rendered
          setTimeout(() => {
            if (call && call.localVideoStreams && call.localVideoStreams.length > 0) {
              const cameraStream = call.localVideoStreams.find(s => s.mediaStreamType === 'Video');
              if (cameraStream && isVideoOnGoing && localVideoContainerRef && localVideoContainerRef.current) {
                displayLocalVideoStream({
                  localVideoStream: cameraStream,
                  localVideoContainerRef,
                  displayName,
                  userId,
                  isAudioOngoingForLocal,
                  participantCount: participantCountGlobal,
                  isScreenSharing,
                });
              }
            }
          }, 150);
        }, 100);
      }, 200);
    }
  });

  const updateCallCreator = (userId, value) => {
    isCallCreator.current[userId] = value;
    setIsUserCallCreator(value);
  };

  const getLocalParticipantDetails = () => {
    return clientObjectArr.find((participant) => participant.userId === userId) || null;
  };

  /**
   * Find ACS camera that matches a browser InputDeviceInfo
   * Uses multiple matching strategies to handle ID format differences
   * @param {Array} acsCameras - Array of ACS VideoDeviceInfo objects
   * @param {InputDeviceInfo} browserDevice - Browser device to match
   * @returns {VideoDeviceInfo|null} Matching ACS camera or null
   */
  const findMatchingACSCamera = useCallback((acsCameras, browserDevice) => {
    if (!acsCameras || !acsCameras.length || !browserDevice) {
      return null;
    }

    // Strategy 1: Exact ID match
    let camera = acsCameras.find(cam => cam.id === browserDevice.deviceId);
    if (camera) {
      console.log('📸 Camera matched by exact ID:', camera.name);
      return camera;
    }

    // Strategy 2: Exact name match
    if (browserDevice.label) {
      camera = acsCameras.find(cam =>
        cam.name && cam.name.toLowerCase() === browserDevice.label.toLowerCase()
      );
      if (camera) {
        console.log('📸 Camera matched by exact name:', camera.name);
        return camera;
      }
    }

    // Strategy 3: Partial name match (handles labels with extra info like "(1124:2925)")
    if (browserDevice.label) {
      const deviceLabelLower = browserDevice.label.toLowerCase();
      camera = acsCameras.find(cam =>
        cam.name && (
          deviceLabelLower.includes(cam.name.toLowerCase()) ||
          cam.name.toLowerCase().includes(deviceLabelLower.split('(')[0].trim().toLowerCase())
        )
      );
      if (camera) {
        console.log('📸 Camera matched by partial name:', camera.name);
        return camera;
      }
    }

    // Strategy 4: Match by index position in device list
    if (availableVideoDevices.length > 0) {
      const deviceIndex = availableVideoDevices.findIndex(d => d.deviceId === browserDevice.deviceId);
      if (deviceIndex !== -1 && deviceIndex < acsCameras.length) {
        camera = acsCameras[deviceIndex];
        console.log('📸 Camera matched by index position:', camera.name);
        return camera;
      }
    }

    return null;
  }, [availableVideoDevices]);

  /**
   * Get the currently active ACS camera (if video is streaming)
   * @returns {VideoDeviceInfo|null} Current camera source or null
   */
  const getCurrentActiveCamera = useCallback(() => {
    if (!call || !call.localVideoStreams) return null;

    const currentVideoStream = call.localVideoStreams.find(
      stream => stream.mediaStreamType === 'Video'
    );

    return currentVideoStream?.source || null;
  }, [call]);

  const CallBackFunctionForGetUnreadMessages = (item) => {
    setTotalUnreadMessageCount(item);
  }

  // Device switching functions for active calls
  const switchAudioDevice = async (device) => {
    try {
      if (!device || !device.deviceId) {
        console.error('Invalid audio device selected');
        return;
      }

      console.log("Device selected:", device);

      // If call is active, update the audio stream with new device
      if (call && call.localVideoStreams) {
        try {
          // Get new audio stream with selected device
          const constraints = {
            audio: {
              deviceId: { exact: device.deviceId }
            }
          };

          console.log('🔍 Constraints:', constraints);

          const newStream = await navigator.mediaDevices.getUserMedia(constraints);

          console.log('🔍 New stream:', newStream);

          // Stop old audio tracks
          call.localVideoStreams.forEach(stream => {
            if (stream.mediaStreamType === 'Audio') {
              // stop all tracks safely
              try {
                stream.getTracks && stream.getTracks().forEach(track => track.stop());
              } catch (e) {
                console.warn('Failed to stop old audio tracks', e);
              }
              // if ACS stream has dispose/stop, attempt it defensively
              if (typeof stream.stop === 'function') {
                try { stream.stop(); } catch (e) { /* ignore */ }
              }
            }
          });

          // Add new audio stream to call
          await call.startAudio(newStream);

          console.log('Successfully switched to microphone:', device.label || device.deviceId);
        } catch (streamError) {
          console.error('Error switching microphone:', streamError);
        }
      }
    } catch (error) {
      console.error('Error selecting microphone:', error);
    }
  };

  /**
   * Switch video device using ACS-compliant approach
   * Handles: during call, before joining, multiple switches, and camera ON/OFF states
   * @param {InputDeviceInfo} device - The video device to switch to
   */
  const switchVideoDevice = async (device) => {
    console.log("🚀 ~ switchVideoDevice ~ device:", device);

    try {
      if (!device || !device.deviceId) {
        console.error('Invalid video device selected');
        return;
      }

      // Case 1: No active call - just update UI selection
      // The new device will be used when startVideo is called
      if (!call) {
        console.log('No active call - updating device selection for next video start');
        selectVideoDevice(device);
        return;
      }

      // Case 2: Active call - need to switch the camera
      if (!deviceManager) {
        console.error('DeviceManager is not initialized');
        return;
      }

      // Get ACS camera devices
      const cameras = await deviceManager.getCameras();

      console.log('🎥 ACS Cameras available:', cameras.map(cam => ({
        id: cam.id,
        name: cam.name
      })));
      console.log('🎯 Looking for device:', {
        deviceId: device.deviceId,
        label: device.label
      });

      // Use robust matching to find the ACS camera
      let targetCamera = findMatchingACSCamera(cameras, device);

      if (!targetCamera) {
        console.error('Selected camera not found in ACS device list.');
        toast.warning('Selected camera not found. Please try another camera.', {
          toastId: 'camera-switch-not-found',
        });
        return;
      }

      // Find current video stream
      const currentVideoStream = call.localVideoStreams?.find(
        stream => stream.mediaStreamType === 'Video'
      );

      // Check if we're already using this camera (prevent "same device" error)
      if (currentVideoStream && currentVideoStream.source) {
        const currentCameraId = currentVideoStream.source.id;
        console.log('🔍 Current camera ID:', currentCameraId);
        console.log('🎯 Target camera ID:', targetCamera.id);

        if (currentCameraId === targetCamera.id) {
          console.log('✅ Camera is already active, no switch needed');
          // Sync the UI state to match reality
          syncSelectedVideoDevice(targetCamera, device);
          return;
        }
      }

      // Case 2a: Video is currently ON during call - switch camera
      if (currentVideoStream && isVideoOnGoing) {
        try {
          // Method 1: Use switchSource if available (ACS SDK >= 1.3.0)
          if (typeof currentVideoStream.switchSource === 'function') {
            console.log('Using switchSource to change camera');
            await currentVideoStream.switchSource(targetCamera);

            // Update state
            setLocalVideoStream(currentVideoStream);

            // Update clientObjectArr
            const ownIndex = clientObjectArr.findIndex(item => item.userId === userId);
            if (ownIndex > -1) {
              clientObjectArr[ownIndex].stream = currentVideoStream;
            }


            setSelectedVideoCameraDevice(targetCamera.name);
            console.log('✅ Successfully switched camera using switchSource:', targetCamera.name || device.label);
          } else {
            // Method 2: Fallback - stop current video and start with new device
            console.log('Using stop/start method to change camera');

            // Stop current video
            await call.stopVideo(currentVideoStream);

            // Small delay to ensure resources are released
            await new Promise(resolve => setTimeout(resolve, 100));

            // Create new LocalVideoStream with the target camera
            const newLocalVideoStream = new LocalVideoStream(targetCamera);

            // Start video with new stream
            await call.startVideo(newLocalVideoStream);

            // Update state
            setLocalVideoStream(newLocalVideoStream);

            // Update clientObjectArr
            const ownIndex = clientObjectArr.findIndex(item => item.userId === userId);
            if (ownIndex > -1) {
              clientObjectArr[ownIndex].stream = newLocalVideoStream;
            }

            console.log('✅ Successfully switched camera using stop/start:', targetCamera.name || device.label);
          }

          // Sync the UI selection state to match the actual ACS camera
          syncSelectedVideoDevice(targetCamera, device);

          // Re-apply video effects after camera switch
          setTimeout(() => {
            applyVideoEffects(appSettings.video);
          }, 200);

        } catch (switchError) {
          console.error('Error switching camera during active video:', switchError);

          // Handle "already selected" error gracefully
          const errorMessage = switchError.message || '';
          if (errorMessage.includes('already selected') || errorMessage.includes('same video device')) {
            console.log('⚠️ Camera already active (ACS error), syncing UI state');
            syncSelectedVideoDevice(targetCamera, device);
            return;
          }

          handleCameraError(switchError);
        }
      }
      // Case 2b: Video is OFF but call is active - just save selection
      // The new device will be used when user turns video ON
      else if (!isVideoOnGoing) {
        console.log('Video is OFF - device selection saved for next video start');
        // Device is already selected via selectVideoDevice, nothing more to do
      }

    } catch (error) {
      console.error('Error in switchVideoDevice:', error);
      handleCameraError(error);
    }
  };

  /**
   * Handle camera-related errors
   * @param {Error} error - The error to handle
   */
  const handleCameraError = (error) => {
    const errorMessage = error.message || error.toString() || '';

    if (error.name === 'CallingCommunicationError' ||
      errorMessage.includes('permission') ||
      errorMessage.includes('Permission') ||
      errorMessage.includes('permission was not granted')) {
      // Show permission error modal
      setPermissionErrorModal({
        isOpen: true,
        deviceType: 'camera'
      });
    }
  };

  /**
   * Sync the UI selection state with the actual ACS camera
   * This ensures the dropdown shows the correct active camera
   * @param {VideoDeviceInfo} acsCamera - The ACS camera that's actually active
   * @param {InputDeviceInfo} browserDevice - The browser device from the dropdown
   */
  const syncSelectedVideoDevice = (acsCamera, browserDevice) => {
    // Find the browser device that corresponds to the ACS camera
    const matchingBrowserDevice = availableVideoDevices.find(d => {
      // Try exact ID match
      if (d.deviceId === acsCamera.id) return true;
      // Try name match
      if (acsCamera.name && d.label &&
        d.label.toLowerCase().includes(acsCamera.name.toLowerCase())) return true;
      return false;
    });

    if (matchingBrowserDevice) {
      console.log('🔄 Syncing UI selection to:', matchingBrowserDevice.label);
      selectVideoDevice(matchingBrowserDevice);
    } else {
      // If no match found, just use the browser device that was clicked
      console.log('🔄 Using clicked device for UI:', browserDevice.label);
      selectVideoDevice(browserDevice);
    }
  };

  /**
   * Handle camera removal/disconnection gracefully
   * - Stops the current ACS video stream safely
   * - Resets local video state and UI
   * - Notifies the user with a toast message
   * - Does NOT auto-switch to another camera (user must explicitly select)
   */
  const handleCameraRemoved = useCallback(async () => {
    try {
      // Only handle if we have an active call with video streaming
      if (!call || !deviceManager || !isVideoOnGoing) return;

      const currentVideoStream = call.localVideoStreams?.find(
        stream => stream?.mediaStreamType === 'Video'
      );

      if (!currentVideoStream || !currentVideoStream.source) return;

      const activeCameraId = currentVideoStream.source.id;
      const cameras = await deviceManager.getCameras();

      // Check if the active camera is still present
      const cameraStillPresent = cameras?.some(cam => cam.id === activeCameraId);

      if (cameraStillPresent) return; // Camera still connected, nothing to do

      console.warn('⚠️ Active camera was removed/disconnected. Stopping video safely.');

      // Stop ACS video stream to prevent crashes
      try {
        await call.stopVideo(currentVideoStream);
      } catch (stopErr) {
        console.warn('Failed to stop video after camera removal:', stopErr);
      }

      // Reset video state
      setIsVideoOnGoing(false);
      videoOption = false;
      setLocalVideoStream(null);

      // Remove local video from UI
      removeLocalVideoStream({
        localVideoContainerRef,
        participantCount,
        participantCountGlobal,
        isRightPanelOpen,
        isAudioOngoingForLocal,
        userId,
        displayName,
        localParticipant: getLocalParticipantDetails?.(),
      });

      // Update clientObjectArr
      const ownIndex = clientObjectArr.findIndex(item => item.userId === userId);
      if (ownIndex > -1) {
        clientObjectArr[ownIndex].stream = null;
        clientObjectArr[ownIndex].isVideoOff = true;
      }

      // Notify the user
      toast.warning('Camera disconnected. Please select another camera to continue video.', {
        toastId: 'camera-disconnected',
        autoClose: 5000,
      });

      // Clear the selected device since it's no longer available
      // User must explicitly select a new camera
      if (selectedVideoDevice) {
        const stillAvailable = availableVideoDevices.some(
          d => d.deviceId === selectedVideoDevice.deviceId
        );
        if (!stillAvailable) {
          selectVideoDevice(null);
        }
      }

    } catch (err) {
      console.error('Error handling camera removal:', err);
    }
  }, [
    call,
    deviceManager,
    isVideoOnGoing,
    selectedVideoDevice,
    availableVideoDevices,
    participantCount,
    isRightPanelOpen,
    isAudioOngoingForLocal,
    userId,
    displayName,
    selectVideoDevice
  ]);

  /**
   * Watch for device list changes and handle camera removal
   * This effect runs when the available video devices list changes
   */
  useEffect(() => {
    // Only check for camera removal if we're in an active call with video
    if (call && isVideoOnGoing) {
      handleCameraRemoved();
    }
  }, [availableVideoDevices, call, isVideoOnGoing, handleCameraRemoved]);

  /**
   * Check if selected camera is still available when user tries to turn on video
   * This handles the case where camera was unplugged while video was off
   */
  const validateSelectedCamera = useCallback(async () => {
    if (!selectedVideoDevice) return true; // No specific camera selected, will use default

    // Check if selected camera is in current device list
    const stillAvailable = availableVideoDevices.some(
      d => d.deviceId === selectedVideoDevice.deviceId
    );

    if (!stillAvailable) {
      console.warn('⚠️ Selected camera is no longer available');
      toast.warning('Previously selected camera not found. Please select a camera.', {
        toastId: 'camera-unavailable',
      });
      selectVideoDevice(null);
      return false;
    }

    return true;
  }, [selectedVideoDevice, availableVideoDevices, selectVideoDevice]);

  // Unified function to close all toggles
  const closeAllToggles = () => {
    setMicrophoneDropdownOpen(false);
    setCameraDropdownOpen(false);
    setIsEndCallDropdownOpen(false);
    setOpenScreenShotMenuList(false);
    setIsMenuListOpen(false);
    setIsThemeOpen(false);
  };

  // Handle microphone dropdown toggle
  const toggleMicrophoneDropdown = (e) => {
    e.stopPropagation();

    // If already open, just close it
    if (microphoneDropdownOpen) {
      setMicrophoneDropdownOpen(false);
    } else {
      // Close all other toggles first
      closeAllToggles();
      // Open microphone dropdown
      setMicrophoneDropdownOpen(true);
      // Refresh devices when opening dropdown
      loadAudioDevices();
    }
  };

  // Handle camera dropdown toggle
  const toggleCameraDropdown = (e) => {
    e.stopPropagation();

    // If already open, just close it
    if (cameraDropdownOpen) {
      setCameraDropdownOpen(false);
    } else {
      // Close all other toggles first
      closeAllToggles();
      // Open camera dropdown
      setCameraDropdownOpen(true);
      // Refresh devices when opening dropdown
      loadVideoDevices();
    }
  };

  const toggleEndCallDropdown = (e) => {
    e.stopPropagation();

    if (isEndCallDropdownOpen) {
      setIsEndCallDropdownOpen(false);
    } else {
      closeAllToggles();
      setIsEndCallDropdownOpen(true);
    }
  };


  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside of any toggle elements
      const isClickInsideToggle = event.target.closest('.feature') ||
        event.target.closest('.menuList') ||
        event.target.closest('.arrow');

      if (!isClickInsideToggle) {
        closeAllToggles();
      }
    };

    // Only add listener if any toggle is open
    if (microphoneDropdownOpen || cameraDropdownOpen || isEndCallDropdownOpen || isMenuListOpen ||
      isThemeOpen || openScreenShotMenuList) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [microphoneDropdownOpen, cameraDropdownOpen, isEndCallDropdownOpen, isMenuListOpen, isThemeOpen, openScreenShotMenuList]);

  const updateStateOfPreJoinSettings = useCallback((localPreJoinSettings) => {
    setPreJoinSettings(localPreJoinSettings);
    micOption = localPreJoinSettings.audio;
    videoOption = localPreJoinSettings.video;
  }, [])

  const ChatIconSVG = () => (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="20" fill="#0096FF" />
      <path
        d="M28 15C28 13.9 27.1 13 26 13H14C12.9 13 12 13.9 12 15V25C12 26.1 12.9 27 14 27H24L28 31V15Z"
        fill="white"
      />
      <rect x="15" y="17" width="10" height="2" fill="#0096FF" />
      <rect x="15" y="21" width="10" height="2" fill="#0096FF" />
    </svg>
  );

  useEffect(() => {
    if (effectRan.current) return;
    deviceManager = null;

    // Start pre-warming CallClient immediately when component mounts
    preWarmCallClient();

    // Call the external function and pass the callback
    const initialize = async () => {
      //const searchParams = new URLSearchParams(window.location.search);
      const query = new URLSearchParams(window.location.search);
      console.log('----query--', query);
      try {
        if (query) {
          acsusrt = query.get('acsusrt')
          acsRoomId = query.get('rmid')
          //secretId = query.get('scrtid')

          console.log(acsusrt)//123
          // console.log('----scrtid--', secretId);
          console.log('----rmid--', acsRoomId);
        }
      } catch (error) {
        console.log(error)
      }

      const { userIdServer, token } = await getAcsToken();
      if (acsusrt == 1) {
        ownerToken = token;
      }
      userAccessToken = token;
      userId = userIdServer
      if (acsusrt == 1) { //admin
        isCallCreator.current[userId] = true;
        setIsUserCallCreator(true);
      } else if (acsusrt == 2) { //seller
        isCallCreator.current[userId] = false;
        setIsUserCallCreator(false);
      } else { //buyer
        isCallCreator.current[userId] = false;
        setIsUserCallCreator(false);
      }
      console.log(socket.id, '----userId--', userId);
      console.log("Type of Acsusrt====> ", typeof acsusrt);
      if (acsusrt && acsRoomId) {
        if (acsusrt == 1) {
          await addParticipantToRoom(acsRoomId, userId)
        } else {
          await addParticipantToRoom(acsRoomId, userId);
        }
        setPagenumber(2);
        try {
          uinfo = query.get('uinfo');
          console.log('----uinfo--', uinfo);
          if (uinfo && uinfo.includes('|')) {
            let uinfoArr = uinfo.split('|');
            progressId = uinfoArr[0];
            usertypeFromQuery = uinfoArr[1];
            userIdFromOdrQueryParam = uinfoArr[2];
            displayName = uinfoArr[3];
            setDisplayNameUi(displayName)
            userIdOfSellerByuerFromOdr = uinfoArr[4];
            isUnmannedUser = uinfoArr[5] === 'N';
            console.log(progressId, usertypeFromQuery, userIdFromOdrQueryParam, displayName, userIdOfSellerByuerFromOdr, isUnmannedUser);
          }
        } catch (error) {
          console.log(error)
        }

      } else {
        setPagenumber(1)
      }
      console.log('-----socket.id-onload---', socket.id)
      socket.emit('init-room', { acsRoomId, userName: userId, joinerSocketId: socket.id, displayName: displayName, uinfo: uinfo }); //when room creation
      const { tokenAzureLogin } = await getAcsLoginToken();
      tokenFromAzureLogin = tokenAzureLogin;
      console.log("tokenAzureLogin---: " + tokenFromAzureLogin)
      //window.addEventListener('beforeunload', handleBeforeUnload);
    }
    cleanInitialVariable()
    receiveServerMessage(socket, upadteReceivedMessageCB);
    oneToOneMessage(socket, updateOneToOneMessageCB);
    updateUiOnAcceptCall(socket, updateUiOnAcceptCallCB);
    userFullyJoined(socket, userFullyJoinedCB);
    updateStatusOnUi(socket, updateStatusOnUiCB);
    onloadCheckUserAlreadyJoined(socket, onloadCheckUserAlreadyJoinedCB);

    // Handle raise hand error responses
    socket.on('FE-update-status-error', (error) => {
      console.error('❌ Raise hand error from server:', error);
      setIsRiseHandLoading(false);

      // Clear timeout on error
      if (riseHandTimeoutRef.current) {
        clearTimeout(riseHandTimeoutRef.current);
        riseHandTimeoutRef.current = null;
      }

      errorToast.error(`Failed to raise hand: ${error.message || 'Unknown error'}`);
    });

    // Handle reconnection - reset raise hand state
    socket.on('reconnect', () => {
      console.log('🔄 Socket reconnected - resetting raise hand state');
      setIsRiseHandLoading(false);
      setRiseHandActiveStatus(false); // Reset to default state

      // Clear any pending timeouts
      if (riseHandTimeoutRef.current) {
        clearTimeout(riseHandTimeoutRef.current);
        riseHandTimeoutRef.current = null;
      }

      // Show reconnection message
      participantToast.info("Reconnected to meeting. Raise hand status reset.");
    });

    // Set the current user ID for local user identification
    window.currentUserId = userId;

    // Ensure local user's raise hand element exists after a short delay
    setTimeout(() => {
      ensureLocalRaiseHandElement();
    }, 1000);

    initialize();

    effectRan.current = true;
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
      //window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
  const cleanInitialVariable = () => {
    clientObjectArr = [];
    clientPagingArr = [];
    serverCallId = '';
    isUserJoinedToRoom = false;
    isOwnRemovedFromCall = false;
    isParticipantOpen = false;
    callDurationInSec = 0;
    isAudioOngoingForLocal = true;
    isRightPanelOpenGlobal = true;
    isUnmannedUser = false;
  }

  const handlePinParticipant = async (participantId, participantName, previousPinnedUser) => {
    console.log(`Pinning participant: ${participantName} (${participantId})`);

    // Use requestAnimationFrame to prevent layout flicker
    requestAnimationFrame(() => {
      setPinnedParticipantId(participantId);
    });
  }

  const handleUnpinParticipant = async (participantName) => {
    console.log(`Unpinning participant: ${participantName}`);

    setPinnedParticipantId(null);

    // Ensure local tile returns to its previous state (camera on/off)
    setTimeout(async () => {
      if (!localVideoContainerRef?.current) {
        console.warn('Local video container not ready after unpin');
        return;
      }

      try {
        const localParticipantDetails = getLocalParticipantDetails();
        if (isVideoOnGoing && localVideoStream) {
          await displayLocalVideoStream({
            localVideoStream,
            localVideoContainerRef,
            displayName: displayNameUi || displayName,
            userId,
            isAudioOngoingForLocal,
            participantCount: participantCountGlobal,
            isScreenSharing,
            localParticipant: localParticipantDetails,
          });
          console.log('Local video restored after unpin');
        } else {
          removeLocalVideoStream({
            localVideoContainerRef,
            participantCount,
            participantCountGlobal,
            isRightPanelOpen,
            isAudioOngoingForLocal,
            userId,
            displayName: displayNameUi || displayName,
            localParticipant: localParticipantDetails,
          });
          console.log('Local placeholder restored after unpin');
        }
      } catch (error) {
        console.error('Error updating local tile after unpin:', error);
      }
    }, 150);
  }

  // const handleBeforeUnload = (event) => {
  //   // Custom message may not be shown in all browsers
  //   const message = "You have unsaved changes. Do you really want to leave?";
  //   event.preventDefault(); // Prevent the default action
  //   event.returnValue = message; // For most browsers
  //   return message; // For older browsers
  // };
  // const updateCallDuration = () => {
  //   // Clear any existing interval to avoid multiple timers running
  //   if (intervalId) {
  //     clearInterval(intervalId);
  //   }

  //   console.log('Starting new timer...');

  //   intervalId = setInterval(() => {
  //     callDurationInSec++;
  //     //console.log('-------inside------', callDurationInSec);

  //     const hrs = Math.floor(callDurationInSec / 3600);
  //     const mins = Math.floor((callDurationInSec % 3600) / 60);
  //     const secs = callDurationInSec % 60;

  //     // Format as 'hh:mm:ss' with leading zeros
  //     const formattedHrs = String(hrs).padStart(2, '0');
  //     const formattedMins = String(mins).padStart(2, '0');
  //     const formattedSecs = String(secs).padStart(2, '0');

  //     setCallDuration(`${formattedHrs}:${formattedMins}:${formattedSecs}`);
  //   }, 1000);
  // };
  const upadteReceivedMessageCB = ({ participantList, dataObj }) => { // receive all participant on joining
    //let milisec=dataObj.callDurationtTime;
    callDurationInSec = dataObj.callDurationtTime;
    console.log(dataObj, "---receive--data-onjoining---", participantList, callDurationInSec);

    if (participantList && participantList.length > 0) {
      if (dataObj.userId == userId) { // new join own 
        clientObjectArr = participantList;

        // FIX: Check for existing lobby users when admin joins the call
        // This handles the case where users joined BEFORE admin started the call
        if (isCallCreator.current[userId] && isUserJoinedToRoom) {
          const lobbyUsers = clientObjectArr.filter(obj => obj.isAcceptedByAdmin === false);
          if (lobbyUsers.length > 0) {
            console.log(`Admin joined and found ${lobbyUsers.length} user(s) already waiting in lobby`);

            // Show a single consolidated notification instead of multiple toasts
            const message = lobbyUsers.length === 1
              ? `${lobbyUsers[0].displayName} is waiting in the lobby`
              : `${lobbyUsers.length} participants are waiting in the lobby`;

            lobbyToast.info(message);

            playLobbyNotificationSound();
            // Auto-open lobby to show waiting users
            checkIfLobbyExistOrNot('lobby-join');
          }
        }
      } else {
        let indexInData = clientObjectArr.findIndex(item => item.userId === dataObj.userId || item.uinfo === dataObj.uinfo)
        if (indexInData > -1) {
          const wasAccepted = clientObjectArr[indexInData].isAcceptedByAdmin;
          const isNowAccepted = dataObj.isAcceptedByAdmin;

          clientObjectArr[indexInData] = dataObj;

          // Check if this is a rejoining user (was accepted before, now not accepted)
          if (isCallCreator.current[userId] && isUserJoinedToRoom && wasAccepted && !isNowAccepted) {
            playLobbyNotificationSound();
            lobbyToast.info(`${dataObj.displayName} is waiting in the lobby`);

            // Auto-open lobby when someone rejoins and needs approval
            checkIfLobbyExistOrNot('lobby-join');
          }
        } else {
          clientObjectArr.push(dataObj); // other participant update in participant list

          // Play notification sound for admin when a new user joins the lobby
          if (isCallCreator.current[userId] && isUserJoinedToRoom && !dataObj.isAcceptedByAdmin) {
            playLobbyNotificationSound();
            lobbyToast.info(`${dataObj.displayName} is waiting in the lobby`);

            // Auto-open lobby when someone joins, or update if already open
            checkIfLobbyExistOrNot('lobby-join');
          }
        }

        // Also update lobby if it's currently open, even for rejoining users
        if (isCallCreator.current[userId] && isUserJoinedToRoom) {
          const tempArr = clientObjectArr.filter(obj => obj.isAcceptedByAdmin === false);
          if (tempArr.length > 0) {
            // Update lobby data - this will open it if not already open, or update if already open
            checkIfLobbyExistOrNot('lobby-join');
          }
        }
      }

      if (isCallCreator.current[userId] && isUserJoinedToRoom) { // for admin
        onloadDisplayPreviewOnLoad();
        // Don't auto-open lobby on every participant list update
        // Only open when someone joins the lobby (handled above)
        // updateCallDuration();
      }
      console.log('--filteredArr--', clientObjectArr);
      // Always update screen share view after participant list update
      if (videoOption) {
        updateScreenShareView();
      }

    } else {
      updateCount(0)
      setDisplayRemoteParticipant([])
      setParticipantCount(0)
    }
  };

  const updateUiOnAcceptCallCB = ({ participantList, dataObj, value, type, userIdFromServer }) => { // Accepted call back
    console.log(userId, "---Accept-Participant oncallback---", participantList, dataObj, value, type, userIdFromServer);
    if (type === 'LeaveFromCall') {
      let index = clientObjectArr.findIndex(item => item.userId === userIdFromServer);
      console.log(clientObjectArr, '----index--remove----', index);
      if (index > -1) {
        // Auto-unpin if the leaving participant was pinned
        if (pinnedParticipantId === userIdFromServer) {
          console.log('Pinned participant is leaving, auto-unpinning:', userIdFromServer);
          const leavingUserName = clientObjectArr[index].displayName || 'User';
          handleUnpinParticipant(leavingUserName);
          infoToast.info(`${leavingUserName} left the meeting and was unpinned.`);
        }

        clientObjectArr.splice(index, 1)
        onloadDisplayPreviewOnLoad();
        updateParticipantListIfIsOpened()
      }
      // Always update screen share view after participant list update
      updateScreenShareView();
    }
    else {
      console.log('---dataObj inside updateUiOnAcceptCallCB function---', dataObj);
      if (dataObj.userId === userId) { // update own data
        console.log('---own data update---');
        clientObjectArr = participantList;
        console.log("--matched----");

        // Show loader for normal users when accepted from lobby
        if (type === 'AcceptLobby' && !isCallCreator.current[userId]) {
          setIsWaitingForApproval(false);
          setIsCallInitializing(true);
          setCallInitError(null);
          setCallInitMessage('Approved! Joining the meeting...');

          // Pre-warm CallClient for faster joining
          preWarmCallClient();

          // Show immediate success feedback
          setCallInitMessage('Approved! Joining the meeting...');
        }

        handleJoinRoomCall();
        if (type === 'AcceptLobby' && dataObj.recordingOnGoingStatus !== 'initial') {
          setRecordingStatus(dataObj.recordingOnGoingStatus)
          setTimeout(() => {
            recordingToast.success('Recording is ongoing.');
          }, 5000);
        }
      }
      // Note: We no longer update other participants' lists here when type === 'AcceptLobby'
      // Instead, we wait for the FE-user-fully-joined event which is triggered after
      // the user's call is fully connected
      else if (type !== 'AcceptLobby') {
        // Only update for non-AcceptLobby types (e.g., other status updates)
        console.log('---other participant data update (non-AcceptLobby)---');
        let index = clientObjectArr.findIndex(item => item.userId === dataObj.userId);
        console.log("--index----", index);
        if (index > -1) {
          clientObjectArr[index].isAcceptedByAdmin = true
        } else {
          clientObjectArr.push(dataObj);
        }
        if (isParticipantOpen) {
          openParticipantList();
        }
        onloadDisplayPreviewOnLoad();

        callDurationInSec = value;
        // Always update screen share view after participant list update
        updateScreenShareView();
      }
    }


    console.log("--after-Accept-Participant oncallback----", clientObjectArr);

  };

  // New callback for when a user has fully joined the call
  const userFullyJoinedCB = ({ participantList, dataObj, userId: joinedUserId, timestamp }) => {
    console.log('User has fully joined the call:', joinedUserId, dataObj);

    // Update participant list for everyone (admin and other participants)
    // This is called AFTER the user's call initialization is complete
    let index = clientObjectArr.findIndex(item => item.userId === joinedUserId);
    if (index > -1) {
      // User already exists, update their data
      clientObjectArr[index] = dataObj;
      clientObjectArr[index].isAcceptedByAdmin = true;
    } else {
      // New user, add to list
      clientObjectArr.push(dataObj);
    }

    // Update UI
    if (isParticipantOpen) {
      openParticipantList();
    }
    onloadDisplayPreviewOnLoad();
    updateScreenShareView();

    console.log("--after-User-Fully-Joined----", clientObjectArr);
  };

  const onloadCheckUserAlreadyJoinedCB = (data) => {
    console.log("--onload check2----", data);
    let uinfoFromServer = data.uinfo
    if (uinfoFromServer === uinfo) {
      let userdata = data.userdata
      if (userdata) { //force remove previous same user from this call
        isModalFor = 'AlreadyExist'
        senderUserIdGlobal = userdata.userId;
        senderSocketIdGlobal = userdata.socketId;
        setIsRecordingModal(true)
      }
      //socket.emit('BE-update-status', { acsRoomId: acsRoomId, senderUserId: userdata.userId, socketId: userdata.socketId, data: null, type: 'RemoveExistingAddSameUser', typeValue: true });
      // if (data.isUInfoExist) {
      //   setIsAlreadyJoined(true)
      // } else {
      //   setIsAlreadyJoined(false)
      // }
    }
  }
  const updateStatusOnUiCB = ({ acsRoomId, senderUserId, socketId, data, type, typeValue, adminId, message }) => {
    if (type === 'adminWantsToRecord') {
      senderUserIdGlobal = senderUserId;
      senderSocketIdGlobal = socketId;

      // Set consent requested flag for all admins/co-hosts
      if (isCallCreator.current[userId]) {
        setIsRecordingConsentRequested(true);
      }

      if (userId !== senderUserId && isUserJoinedToRoom) {
        isModalFor = 'Recording';
        setIsRecordingModal(true);
      }
    } else if (type === 'makeCoHost') {
      if (userId === senderUserId) {
        // addParticipantToRoom(acsRoomId, userId, 'Presenter');
        updateCallCreator(userId, true);
        participantToast.success('You are now a co-host');
      }
      clientObjectArr.forEach((participant) => {
        if (participant.userId === senderUserId) {
          participant.userType = "Admin";
          participant.cohost = true;
          participant.isCallCreator = true;
        }
      });
      if (isParticipantOpen) {
        openParticipantList();
      }
    } else if (type === 'removeCoHost') {
      if (userId === senderUserId) {
        // addParticipantToRoom(acsRoomId, userId, 'Presenter');
        updateCallCreator(userId, false);
        participantToast.success('Your co-host rights have been removed');
      }
      clientObjectArr.forEach((participant) => {
        if (participant.userId === senderUserId) {
          participant.userType = "Other";
          participant.cohost = false;
          participant.isCallCreator = false;
        }
      });
      if (isParticipantOpen) {
        openParticipantList();
      }
    } else if (type === "TransferRecording") {
      if (userId === senderUserId) {
        console.log('Inside the TransferRecording condition');
        setRecordingId(data.recordingId);
        setRecordingStatus('paused');
        recordingToast.success('Recording transfer request received from ' + displayName);
      } else {
        recordingToast.error('Recording transfer request received from ' + displayName);
      }
    } else if (type === 'BroadCastMessage') {
      if (isUserJoinedToRoom) {
        if (data.isSuccessMsg)
          recordingToast.success(typeValue); // recording started and 
        else
          recordingToast.error(typeValue);
      }

      // Update recording status for all users except the one who initiated the recording
      // This ensures that when host/co-host starts recording, other admins get their button disabled
      if (data.status === 'RecordingStarted') {
        setRecordingInitiatorId(senderUserId);
        setIsRecordingConsentRequested(false); // Reset consent requested state
        if (senderUserId !== userId) {
          setRecordingStatus('started');
        }
      } else if (data.status === 'RecordingPaused') {
        if (senderUserId !== userId) {
          setRecordingStatus('paused');
        }
      } else if (data.status === 'RecordingResume') {
        if (senderUserId !== userId) {
          setRecordingStatus('started');
        }
      } else if (data.status === 'RecordingStopped') {
        setRecordingInitiatorId(null);
        setIsRecordingConsentRequested(false); // Reset consent requested state
        if (senderUserId !== userId) {
          setRecordingStatus('initial');
        }
      } else if (data.status === 'RecordingFailed') {
        setIsRecordingConsentRequested(false); // Reset consent requested state on failure
      }
    } else if (type === 'EndCallByAdmin') {
      clientObjectArr = [];
      disconnectCall(type);
      setRejoinBtnShowStatus(false);
    } else {
      let index = clientObjectArr.findIndex(item => item.userId === senderUserId);

      // Handle screen sharing messages regardless of whether sender is in clientObjectArr
      if (type === 'RenderScreenShare') {
        setIsScreenShared(true);
        // Update the participant's screen sharing status in clientObjectArr
        if (index > -1) {
          clientObjectArr[index].isScreenSharing = true;
          screenSharerUserId = clientObjectArr[index].userId;
        }
        // Only set isScreenSharing to true if this user is the one who started screen sharing
        if (userId === senderUserId) {
          setIsScreenSharing(true);
        }
        updateScreenShareView();
      } else if (type === 'StopScreenShare') {
        setIsScreenShared(false);
        // Update the participant's screen sharing status in clientObjectArr
        if (index > -1) {
          clientObjectArr[index].isScreenSharing = false;
          screenSharerUserId = null;
        }
        // Only set isScreenSharing to false if this user is the one who stopped screen sharing
        if (userId === senderUserId) {
          setIsScreenSharing(false);
        }
        // Update UI to reflect screen sharing stop
        setTimeout(() => {
          updateScreenShareView();
          onloadDisplayPreviewOnLoad();
        }, 200);
      } else if (index > -1) {
        if (type == 'updateRiseHand') {
          console.log(`🖐️ Server response - senderUserId: ${senderUserId}, local userId: ${userId}, typeValue: ${typeValue}`);
          clientObjectArr[index].isRiseHand = typeValue;

          // Update current user's raise hand status if this is the current user
          if (senderUserId === userId) {
            // Clear timeout to prevent false error messages
            if (riseHandTimeoutRef.current) {
              clearTimeout(riseHandTimeoutRef.current);
              riseHandTimeoutRef.current = null;
            }

            // Use functional updates to prevent race conditions
            setRiseHandActiveStatus(prevStatus => {
              if (prevStatus !== typeValue) {
                console.log('🖐️ Updated current user raise hand status:', typeValue);
                return typeValue;
              }
              return prevStatus;
            });

            setIsRiseHandLoading(prevLoading => {
              if (prevLoading) {
                // Use setTimeout to avoid React render cycle issues
                setTimeout(() => {
                  if (typeValue) {
                    participantToast.success("Hand raised");
                  } else {
                    participantToast.info("Hand lowered");
                  }
                }, 0);
                return false;
              }
              return prevLoading;
            });
          }

          updateParticipantListIfIsOpened();

          // For local user, also update the local video stream directly
          if (senderUserId === userId) {
            console.log(`🖐️ Updating local user's raise hand status directly`);

            // Ensure the local user's raise hand element exists
            const localRaiseHandElement = ensureLocalRaiseHandElement();
            if (localRaiseHandElement) {
              localRaiseHandElement.style.display = typeValue ? 'block' : 'none';
              console.log(`🖐️ Updated local user's raise hand element directly:`, typeValue);
            } else {
              console.error(`❌ Failed to create or find local user's raise hand element`);
            }
          }

          updateUiOnDemand(senderUserId, 'updateRiseHand', typeValue, userId);
        } else if (type === 'updateMuteUnmute') {
          clientObjectArr[index].isMute = typeValue;
          updateParticipantListIfIsOpened();
          updateUiOnDemand(senderUserId, 'updateMuteUnmute', typeValue);
        } else if (type === 'updateVideoOnOff') {
          clientObjectArr[index].isVideoOff = typeValue;
          updateParticipantListIfIsOpened();
          onloadDisplayPreviewOnLoad();
        } else if (type === "AskToStartVideo") {
          if (userId === senderUserId) {
            setAdminId(adminId);
            // Find the admin's name from clientObjectArr
            const adminUser = clientObjectArr.find(participant => participant.userId === adminId);
            const adminDisplayName = adminUser ? adminUser.displayName : "Admin";
            setRequesterName(adminDisplayName);
            setRequestedAccessName("Camera");
            setIsRequestedModalOpen(true);
          }
        } else if (type === "AskToUnmute") {
          if (userId === senderUserId) {
            setAdminId(adminId);
            // Find the admin's name from clientObjectArr
            const adminUser = clientObjectArr.find(participant => participant.userId === adminId);
            const adminDisplayName = adminUser ? adminUser.displayName : "Admin";
            setRequesterName(adminDisplayName);
            setRequestedAccessName("Mic");
            setIsRequestedModalOpen(true);
          }
        } else if (type === "RequestAcceptedMessage") {
          if (userId === senderUserId) {
            // successToast.success(message)
          }
        } else if (type === "RequestDeniedMessage") {
          if (userId === senderUserId) {
            // infoToast.info(message)
          }
        } else if (type === "ScreenSharePermissionRequest") {
          // Handle screen share permission request (for admins)
          if (isCallCreator.current[userId] && userId !== senderUserId) {
            const requestData = handleScreenSharePermissionRequest(data);
            setScreenShareRequestData(requestData);
            setIsScreenSharePermissionModalOpen(true);
          }
        } else if (type === "ScreenSharePermissionResponse") {
          // Check if this message is for the current user (the requesting user)
          if (userId === senderUserId) {
            handleScreenSharePermissionResponse(data);
            if (data.approved) {
              screenShareToast.success(`Screen share request approved by ${data.adminName}`);
            } else {
              screenShareToast.info(`Screen share request denied by ${data.adminName}`);
            }
          }
          // Notify other admins about the decision
          else if (isCallCreator.current[userId] && userId !== data.adminId) {
            setIsScreenSharePermissionModalOpen(false);
            setScreenShareRequestData(null);
            screenShareToast.info(`Screen share request ${data.approved ? 'approved' : 'denied'} by ${data.adminName}`);
          }
        } else if (type === "ForceStopScreenShare") {
          // Force stop current screen share when admin approves new request or admin overrides
          if (userId === data.currentScreenSharerId) {
            forceStopScreenSharing();
            if (data.adminOverride) {
              screenShareToast.info("Your screen share has been stopped by an admin who started their own screen share");
            } else {
              screenShareToast.info("Your screen share has been stopped by admin approval of another user's request");
            }
          }
          // Update the participant's screen sharing status in clientObjectArr
          if (data.currentScreenSharerId) {
            const screenSharerIndex = clientObjectArr.findIndex(item => item.userId === data.currentScreenSharerId);
            if (screenSharerIndex > -1) {
              clientObjectArr[screenSharerIndex].isScreenSharing = false;
            }
          }
        } else if (type === "ScreenShareRequestTimeout") {
          // Handle screen share request timeout
          if (userId === senderUserId) {
            screenShareToast.info("Screen share request timed out. No admin responded within 30 seconds.");
          } else if (isCallCreator.current[userId]) {
            setIsScreenSharePermissionModalOpen(false);
            setScreenShareRequestData(null);
            screenShareToast.info("Screen share request timed out.");
          }
        } else if (type === 'forceVideoOff') {
          clientObjectArr[index].isVideoOff = typeValue;
          if (userId === senderUserId) {
            if (isVideoOnGoing) {
              const localVideoStream = call.localVideoStreams.find((stream) => { return stream.mediaStreamType === 'Video' });
              call.stopVideo(localVideoStream);
              setIsVideoOnGoing(false);
              videoOption = false;
            }
          }
        } else if (type === 'forceMute') {
          clientObjectArr[index].isMute = typeValue;
          if (userId === senderUserId) {
            if (isAudioOnGoing) {
              call.mute();
            }
            isAudioOngoingForLocal = !typeValue;
            setIsAudioOnGoing(!isAudioOnGoing);
          }
          updateParticipantListIfIsOpened();
          updateUiOnDemand(senderUserId, 'updateMuteUnmute', typeValue);
          setRejoinBtnShowStatus(true);
        } else if (type === 'RejectLobby') {
          let indexInData = clientObjectArr.findIndex(item => item.userId === senderUserId);
          if (indexInData > -1) {
            clientObjectArr.splice(indexInData, 1);
          }
          if (userId === senderUserId) {
            setIsWaitingForApproval(false);
            setPagenumber(2);
            setDynamicMessage('Your request to join has been declined by the host');
          }
          if (isParticipantOpen) {
            openParticipantList();
          }
        } else if (type === 'ForceRemoved' || type === 'RemoveExistingAddSameUser') {
          let index = clientObjectArr.findIndex(item => item.userId === senderUserId);
          if (index > -1) {
            // Auto-unpin if the removed participant was pinned
            if (pinnedParticipantId === senderUserId) {
              console.log('Pinned participant was removed, auto-unpinning:', senderUserId);
              const removedUserName = clientObjectArr[index].displayName || 'User';
              handleUnpinParticipant(removedUserName);
              infoToast.info(`${removedUserName} was removed and unpinned.`);
            }

            clientObjectArr.splice(index, 1);
          }
          if (userId === senderUserId) {
            disconnectCall(type);
            setRejoinBtnShowStatus(type === 'ForceRemoved');
          } else {
            if (isParticipantOpen) {
              openParticipantList();
            }
            onloadDisplayPreviewOnLoad();
          }
        } else if (type === 'ClickOnDisconnect') {
          let index = clientObjectArr.findIndex(item => item.userId === senderUserId);
          if (index > -1) {
            // Auto-unpin if the disconnecting participant was pinned
            if (pinnedParticipantId === senderUserId) {
              console.log('Pinned participant disconnected, auto-unpinning:', senderUserId);
              const disconnectedUserName = clientObjectArr[index].displayName || 'User';
              handleUnpinParticipant(disconnectedUserName);
              infoToast.info(`${disconnectedUserName} disconnected and was unpinned.`);
            }

            clientObjectArr.splice(index, 1);
          }
          if (userId === senderUserId) {
            setRejoinBtnShowStatus(true);
          } else {
            if (isParticipantOpen) {
              openParticipantList();
            }
            onloadDisplayPreviewOnLoad();
          }
        } else if (type === 'rejectRecording') {
          if (isCallCreator.current[userId]) {
            const index = clientObjectArr.findIndex(item => item.userId === data.userId);
            if (index > -1) {
              clientObjectArr[index].recordingStatus = 'reject';
              clientObjectArr[index].isAllowRecording = false;
            }
          }

          if (senderUserId === userId) {
            const filteredArr = clientObjectArr.filter(obj => obj.isAcceptedByAdmin == true && obj.userId != userId);
            openParticipantPanel('participantForRecording');
            modalRefParticipant.current.update(filteredArr);
            modalRefParticipant.current.updateDynamicMsg('Rejected by ' + data.displayName);
          }

          evaluateRecordingConsentState();
          recordingToast.error('Recording permission denied by ' + data.displayName);
        } else if (type === 'acceptRecording') {
          recordingStartBeforeJoining = true;

          if (isCallCreator.current[userId]) {
            const index = clientObjectArr.findIndex(item => item.userId === data.userId);
            if (index > -1) {
              clientObjectArr[index].recordingStatus = 'accept';
              clientObjectArr[index].isAllowRecording = true;
            }
          }

          if (senderUserId === userId) {
            const filteredArr = clientObjectArr.filter(obj => obj.isAcceptedByAdmin == true && obj.userId != userId);
            openParticipantPanel('participantForRecording');
            modalRefParticipant.current.update(filteredArr);

            const pendingIndex = filteredArr.findIndex(item => !item.isAllowRecording);
            if (pendingIndex < 0) {
              // All participants have accepted - always show language modal for confirmation
              setIsLanguageModal(true);
            }
          }

          evaluateRecordingConsentState();
        } else if (type === 'adminResendRecordingRequest') {
          if (senderUserId === userId) {
            setIsRecordingModal(true);
          }

        }
      }
    }
  };
  const startRecordingFromUi = async (language) => {
    let recordingObj = {}
    if (serverCallId) {
      toast.loading('Connecting to the server...');
      recordingObj = await startRecording(serverCallId, callId, progressId, language)
      toast.dismiss()
      console.log("---recordingObj1----", recordingObj);
    } else {
      let serverCallObj = await getServerCallId(callId, tokenFromAzureLogin);
      console.log("---serverCallObj--11--", serverCallObj);
      if (serverCallObj && serverCallObj.serverCallId) {
        serverCallId = serverCallObj.serverCallId
        toast.loading('Connecting to the server...');
        recordingObj = await startRecording(serverCallId, callId, progressId, language)
        toast.dismiss();
        console.log("---recordingObj--22--", recordingObj);
      } else {
        alert('server callId not found')
      }
    }
    console.log("---recordingObj--33--", recordingObj);
    if (recordingObj && recordingObj.recordingId) {
      modalRefParticipant.current.updateDynamicMsg('All Participants have agreed to recording.');
      recordingToast.success('Recording has started.');
      setRecordingStatus('starting');
      setRecordingInitiatorId(userId);
      setIsRecordingConsentRequested(false); // Reset consent requested state
      socket.emit('BE-update-status', { acsRoomId: acsRoomId, senderUserId: userId, socketId: socket.id, data: { isSuccessMsg: true, status: 'RecordingStarted' }, type: 'BroadCastMessage', typeValue: 'Recording has started' });
      modalRefParticipant.current.updateRecordingFlag('started');
    } else {
      recordingToast.error('Recording failed to start due to a technical issue.');
      setIsRecordingConsentRequested(false); // Reset consent requested state on failure
      socket.emit('BE-update-status', { acsRoomId: acsRoomId, senderUserId: userId, socketId: socket.id, data: { isSuccessMsg: false, status: 'RecordingFailed' }, type: 'BroadCastMessage', typeValue: 'Recording failed to start due to a technical issue.' });
    }

  }
  const updateParticipantListIfIsOpened = () => {
    console.log("---isParticipantOpen----", isParticipantOpen);
    if (isParticipantOpen) {
      const filteredArr = clientObjectArr.filter(obj => obj.isAcceptedByAdmin == true);
      modalRefParticipant.current.update(filteredArr);
    }
  }
  const updateOneToOneMessageCB = (data) => { //{ acsRoomId, senderUserId, socketId, type, data }
    console.log('-----receive one to one1-----', data)
    if (data.type === 'alreadyExist') {
      errorToast.error(data.message)
      setDynamicMessage(data.message)
    } else if (data.type === 'CloseBrowser') {
      let index = clientObjectArr.findIndex(item => item.socketId === data.SocketId)
      console.log('-----find-----', index, isLobbyOpen, isParticipantOpen, isRightPanelOpen)
      if (index > -1) {
        clientObjectArr.splice(index, 1);
        if (isRightPanelOpenGlobal) {
          if (isLobbyOpen) {
            checkIfLobbyExistOrNot('onclick');
          } else if (isParticipantOpen) {
            openParticipantList()
          } else {
            console.log('-----rec -----')
            const filteredArr = clientObjectArr.filter(obj => obj.isAcceptedByAdmin == true && obj.userId != userId);
            openParticipantPanel('participantForRecording')
            modalRefParticipant.current.update(filteredArr);
          }
        }

        console.log('-----close -----', clientObjectArr)
      }
    }

  };
  // Pre-warm CallClient for faster initialization
  const preWarmCallClient = async () => {
    if (preWarmedCallClient || isPreWarmingInProgress) return;

    isPreWarmingInProgress = true;
    try {
      preWarmedCallClient = new CallClient();

      // Also pre-warm device manager
      const deviceManager = await preWarmedCallClient.getDeviceManager();
      await Promise.all([
        deviceManager.askDevicePermission({ video: true }),
        deviceManager.askDevicePermission({ audio: true })
      ]);

      console.log('CallClient and DeviceManager pre-warmed successfully');
    } catch (error) {
      console.error('Error pre-warming CallClient:', error);
    } finally {
      isPreWarmingInProgress = false;
    }
  };

  const initializeCall = async () => {
    try {
      // Use pre-warmed client or create new one
      const callClient = preWarmedCallClient || new CallClient();
      const tokenCredential = new AzureCommunicationTokenCredential(userAccessToken.trim());

      // Initialize call agent and device manager in parallel for faster setup
      const [agent, manager] = await Promise.all([
        callClient.createCallAgent(tokenCredential, { displayName: displayName + '###' + uinfo }),
        callClient.getDeviceManager()
      ]);

      callAgent = agent;
      deviceManager = manager;

      // Request device permissions in parallel instead of sequentially
      await Promise.all([
        manager.askDevicePermission({ video: true }),
        manager.askDevicePermission({ audio: true })
      ]);

    } catch (error) {
      console.error('-------err-', error);
      setCallInitError('Failed to initialize call client. Please check your permissions and try again.');
      setIsCallInitializing(false);

      // Clear timeout
      if (callInitTimeoutRef.current) {
        clearTimeout(callInitTimeoutRef.current);
        callInitTimeoutRef.current = null;
      }
      return false;
    }

    if (!deviceManager) {
      console.error('DeviceManager is not initialized.');
      setCallInitError('Failed to access camera and microphone. Please check your permissions and try again.');
      setIsCallInitializing(false);

      // Clear timeout
      if (callInitTimeoutRef.current) {
        clearTimeout(callInitTimeoutRef.current);
        callInitTimeoutRef.current = null;
      }
      return false;
    }

    // Join immediately without any delays
    try {
      const roomCallLocator = { roomId: acsRoomId.trim() };

      // Create video stream asynchronously after joining to avoid delay
      let videoOptions = undefined;
      if (videoOption) {
        // Start video stream creation in background
        createLocalVideoStream().then(localStream => {
          if (localStream && call) {
            call.startVideo(localStream).then(() => {
              console.log('✅ Initial video started successfully');
              setLocalVideoStream(localStream);
            }).catch(error => {
              console.error('Error starting video:', error);
              const errorMessage = error.message || error.toString() || '';
              if (error.name === 'CallingCommunicationError' ||
                errorMessage.includes('permission') ||
                errorMessage.includes('Permission') ||
                errorMessage.includes('permission was not granted')) {
                setPermissionErrorModal({
                  isOpen: true,
                  deviceType: 'camera'
                });
                setIsVideoOnGoing(false);
                videoOption = false;
              }
            });
          } else if (!localStream) {
            // createLocalVideoStream returned null - camera not found
            console.warn('⚠️ Could not create video stream - camera not available');
            setIsVideoOnGoing(false);
            videoOption = false;
          }
        }).catch(error => {
          console.error('Error creating video stream:', error);
          const errorMessage = error.message || error.toString() || '';
          if (errorMessage.includes('permission') ||
            errorMessage.includes('Permission') ||
            errorMessage.includes('NotAllowedError')) {
            setPermissionErrorModal({
              isOpen: true,
              deviceType: 'camera'
            });
            setIsVideoOnGoing(false);
            videoOption = false;
          }
        });
      }

      // Apply audio constraints for noise/echo cancellation
      const audioOptions = {
        muted: !micOption,
        // Add constraints if microphone is enabled
        ...(micOption && {
          constraints: {
            echoCancellation: appSettings.voice.echoCancellation,
            noiseSuppression: appSettings.voice.noiseCancellation,
            autoGainControl: appSettings.voice.advancedNoiseSuppression
          }
        })
      };

      const callOPtions = {
        videoOptions,
        audioOptions,
      }

      // Join the call immediately
      call = callAgent.join(roomCallLocator, callOPtions);

      // Apply audio constraints after joining if mic is enabled
      if (micOption) {
        setTimeout(() => {
          applyAudioConstraints();
        }, 500);
      }

      // Initialize the audio state based on pre-join settings
      setIsAudioOnGoing(micOption);
      setIsVideoOnGoing(videoOption);
      isAudioOngoingForLocal = micOption;

      // Handle video removal asynchronously
      if (!videoOption && localVideoContainerRef && localVideoContainerRef.current) {
        // Use requestAnimationFrame for immediate execution
        requestAnimationFrame(() => {
          removeLocalVideoStream({
            localVideoContainerRef,
            participantCount: 1,
            participantCountGlobal: 1,
            isRightPanelOpen,
            isAudioOngoingForLocal,
            userId,
            displayName
          });
        });
      }

      subscribeToCall(call);
      isUserJoinedToRoom = true;

      // Hide loading immediately after joining
      setIsCallInitializing(false);

    } catch (error) {
      console.error(error);
      setCallInitError('Failed to join the call. Please check your connection and try again.');
      setIsCallInitializing(false);

      // Clear timeout
      if (callInitTimeoutRef.current) {
        clearTimeout(callInitTimeoutRef.current);
        callInitTimeoutRef.current = null;
      }
    }

    if (isCallCreator.current[userId]) {
      onloadDisplayPreviewOnLoad();
    }

    // Run API call in background without blocking the call setup
    startAndJoinCallApi(tokenFromAzureLogin, uinfo + '|J|').catch(error => {
      console.error('Background API call failed:', error);
    });

    selectLanForRecording = '';
    return true;
  };

  const handleJoinRoomCall = async () => {
    setPagenumber(3)

    // Show loader for call initialization
    setIsCallInitializing(true);
    setCallInitError(null);
    setCallInitMessage(isCallCreator.current[userId] ? 'Setting up your meeting...' : 'Connecting to the meeting...');

    // Reduce timeout to 10 seconds for faster feedback
    callInitTimeoutRef.current = setTimeout(() => {
      setIsCallInitializing(false);
      setCallInitError('Connection timeout. Please check your internet connection and try again.');
    }, 10000); // 10 seconds timeout

    try {
      // Start initialization immediately without await to avoid blocking
      initializeCall().then(() => {
        // Clear timeout if call initialization completes successfully
        if (callInitTimeoutRef.current) {
          clearTimeout(callInitTimeoutRef.current);
          callInitTimeoutRef.current = null;
        }
      }).catch(error => {
        console.error('Error in initializeCall:', error);
        setIsCallInitializing(false);
        setCallInitError('Failed to join the meeting. Please try again.');

        // Clear timeout on error
        if (callInitTimeoutRef.current) {
          clearTimeout(callInitTimeoutRef.current);
          callInitTimeoutRef.current = null;
        }
      });

    } catch (error) {
      console.error('Error in handleJoinRoomCall:', error);
      setIsCallInitializing(false);
      setCallInitError('Failed to join the meeting. Please try again.');

      // Clear timeout on error
      if (callInitTimeoutRef.current) {
        clearTimeout(callInitTimeoutRef.current);
        callInitTimeoutRef.current = null;
      }
    }
  };
  const subscribeToCall = (call) => {
    callId = call.id;
    try {
      console.log(`Call Id: ${call.id}`);
      call.on('idChanged', () => console.log(`Call Id changed: ${call.id}`));
      console.log(`Call state: ${call.state}`);

      // If call is already connected, don't show loader
      if (call.state === 'Connected') {
        setIsCallInitializing(false);
        setCallInitError(null);

        // Notify server that this user has fully joined the call
        const userData = clientObjectArr.find(u => u.userId === userId);
        if (userData) {
          const safeUserData = sanitizeParticipantData(userData);
          console.log('Call already connected, notifying server that user has fully joined:', userId);
          socket.emit('BE-user-fully-joined', {
            acsRoomId,
            userId,
            dataObj: safeUserData
          });
        }
      }

      call.on('stateChanged', async () => {
        console.log(`Call state changed: ${call.state}`);
        if (call.state === 'Connected') {
          console.log('user connected to call');

          // Hide loader when call is successfully connected
          setIsCallInitializing(false);
          setCallInitError(null);

          // Clear timeout
          if (callInitTimeoutRef.current) {
            clearTimeout(callInitTimeoutRef.current);
            callInitTimeoutRef.current = null;
          }

          // Notify server that this user has fully joined the call
          // This will trigger the server to notify all other participants
          const userData = clientObjectArr.find(u => u.userId === userId);
          if (userData) {
            const safeUserData = sanitizeParticipantData(userData);
            console.log('Notifying server that user has fully joined:', userId);
            socket.emit('BE-user-fully-joined', {
              acsRoomId,
              userId,
              dataObj: safeUserData
            });
          }

          setTimeout(() => { //get server call id
            if (isCallCreator.current[userId])
              getServerCallIdApi(call.id)
          }, 5000)
          setTimeout(() => { //if not get server call id try 2nd times
            if (isCallCreator.current[userId] && !serverCallId)
              getServerCallIdApi(call.id)
          }, 10000)
        } else if (call.state === 'Disconnected') {
          console.log(`Call ended, call end reason={code=${call.callEndReason.code}, subCode=${call.callEndReason.subCode}}`);

          resetVisualEffects();

          // Hide loader if call gets disconnected during initialization
          if (isCallInitializing) {
            setIsCallInitializing(false);
            setCallInitError('Call connection was lost. Please try again.');

            // Clear timeout
            if (callInitTimeoutRef.current) {
              clearTimeout(callInitTimeoutRef.current);
              callInitTimeoutRef.current = null;
            }
          }
        } else if (call.state === 'Connecting') {
          // Update message when call is connecting
          setCallInitMessage('Connecting to the meeting...');
        }
      });
      call.on('isLocalVideoStartedChanged', () => {
        console.log(`isLocalVideoStarted changed: ${call.isLocalVideoStarted}`)
      });

      call.localVideoStreams.forEach(async (lvs) => {
        setLocalVideoStream(lvs);
        console.log("DisplayLocalVideoStream line number1069 ")
        if (videoOption) {
          const localParticipantDetails = getLocalParticipantDetails();
          await displayLocalVideoStream({
            localVideoStream: lvs,
            localVideoContainerRef,
            displayName,
            userId,
            isAudioOngoingForLocal,
            participantCount: participantCountGlobal,
            isScreenSharing,
            localParticipant: localParticipantDetails,
          })
        }
      });
      call.on('localVideoStreamsUpdated', (e) => {
        e.added.forEach(async (lvs) => {
          if (!isScreenShared && lvs.mediaStreamType === 'Video') {
            setLocalVideoStream(lvs);
            console.log("DisplayLocalVideoStream line number 728");
            const localParticipantDetails = getLocalParticipantDetails();
            await displayLocalVideoStream({
              localVideoStream: lvs,
              localVideoContainerRef,
              displayName,
              userId,
              isAudioOngoingForLocal,
              participantCount: participantCountGlobal,
              isScreenSharing,
              localParticipant: localParticipantDetails,
            });
          }
        });
        e.removed.forEach(() =>
          removeLocalVideoStream({
            localVideoContainerRef,
            participantCount,
            participantCountGlobal,
            isRightPanelOpen,
            isAudioOngoingForLocal,
            userId,
            displayName,
            localParticipant: getLocalParticipantDetails(),
          }),
        )
      });

      //call.remoteParticipants.forEach(subscribeToRemoteParticipant); // can comment
      call.on('remoteParticipantsUpdated', (e) => {

        const participants = call.remoteParticipants;
        const participantCountLocal = (participants.length) + 1; // 
        participantCountGlobal = participantCountLocal;
        console.log(participants.length, '---------participantCountLocal--------' + participantCountLocal);
        setParticipantCount(participantCountLocal)
        setTotalParticipantCount(participantCountLocal) // Update global Jotai atom
        if ((participantCountGlobal == 2 || participantCountGlobal == 3) && !isVideoOnGoing)
          removeLocalVideoStream({
            localVideoContainerRef,
            participantCount,
            participantCountGlobal,
            isRightPanelOpen,
            isAudioOngoingForLocal,
            userId,
            displayName,
            localParticipant: getLocalParticipantDetails(),
          })

        e.added.forEach((participant) => {
          console.log('Call Subscribe Remote Participant at line number 1136');
          isParticipantRemoved = false;
          subscribeToRemoteParticipant(participant)
        });
        e.removed.forEach((participant) => {
          isParticipantRemoved = true;
          console.log('Call Subscribe Remote Participant at line number 1142');
          subscribeToRemoteParticipant(participant)
        });

        updateScreenShareView();
      });

      call.on('isScreenSharingOnChanged', () => {

        if (call.isScreenSharingOn) {
          setIsScreenShared(true);
          setIsScreenSharing(true);
        } else {
          setIsScreenShared(false);
          setIsScreenSharing(false);

          // Emit socket event to notify other participants
          socket.emit('BE-update-status', {
            acsRoomId: acsRoomId,
            senderUserId: userId,
            socketId: socket.id,
            type: 'StopScreenShare'
          });

          // Update UI after a short delay to ensure screen share is completely stopped
          setTimeout(() => {
            updateScreenShareView();
            onloadDisplayPreviewOnLoad();
          }, 200);
        }
      });

    } catch (error) {
      console.error(error);
    }
  };
  const getServerCallIdApi = async (callid) => {
    let serverCallObj = await getServerCallId(callid, tokenFromAzureLogin);
    if (serverCallObj) {
      serverCallId = serverCallObj.serverCallId
    }
    console.log('-----serverCallId--onload----', serverCallId)

  }

  const subscribeToRemoteParticipant = (remoteParticipant) => {
    let participantId = remoteParticipant.identifier.communicationUserId;
    let splitArr = remoteParticipant.displayName.split('###')
    let disName = splitArr[0];
    let uInfomFromParticipant = splitArr[1];
    try {
      remoteParticipant.on('stateChanged', () => {
        console.log(`Remote participant state changed: ${remoteParticipant.state}`)
      });

      if (isParticipantRemoved) {
        let index = clientObjectArr.findIndex(item => item.userId === participantId)
        if (index > -1) {
          clientObjectArr.splice(index, 1);
          console.log('removed from clientObjectArr ', disName, participantId);
        }
        startAndJoinCallApi(tokenFromAzureLogin, uInfomFromParticipant + '|L|') //update to ord multiple times for remove participant
        //remove from call and update server and all participant
        console.log('---before call L--', participantId, disName, uInfomFromParticipant);
        if (!isOwnRemovedFromCall) //no call for own remove.
          socket.emit('BE-admit-room', { acsRoomId: acsRoomId, userId: participantId, SocketId: null, dataObj: null, value: uInfomFromParticipant, type: 'LeaveFromCall' });

      } else {
        remoteParticipant.videoStreams.forEach(stream => {
          stream.on('isAvailableChanged', updateScreenShareView);
          // Only assign the user's own camera stream to participant.stream
          if (stream.mediaStreamType === 'Video') {
            let index = clientObjectArr.findIndex(item => item.userId === participantId)
            console.log('Check the index of the participant in clientObjectArr', index);
            if (index > -1) {
              clientObjectArr[index].stream = stream;
            }
          }
          // Do NOT assign screen sharing stream to participant.stream
        });
      }

      onloadDisplayPreviewOnLoad()
      updateScreenShareView(); // Always check for screen share after participant update
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Create a LocalVideoStream using the user's selected camera
   * Uses robust matching to find the correct ACS camera
   * Shows toast if selected camera not found and doesn't auto-fallback
   * @returns {LocalVideoStream|null} The created stream or null if camera not found
   */
  const createLocalVideoStream = async () => {
    if (!deviceManager) {
      console.error('DeviceManager is not initialized.');
      return null;
    }

    const cameras = await deviceManager.getCameras();
    console.log('🎥 Available ACS cameras:', cameras.map(c => ({ id: c.id, name: c.name })));

    if (!cameras || cameras.length === 0) {
      console.error('No camera devices found on the system');
      toast.error('No camera detected. Please connect a camera to continue.', {
        toastId: 'no-camera-detected',
      });
      return null;
    }

    let camera = null;

    // If user has selected a specific camera, find it using robust matching
    if (selectedVideoDevice) {
      console.log('🎯 Looking for selected camera:', selectedVideoDevice.label || selectedVideoDevice.deviceId);
      camera = findMatchingACSCamera(cameras, selectedVideoDevice);

      if (!camera) {
        console.warn('⚠️ Selected camera not found in ACS device list');
        toast.warning('Selected camera not found. Please select another camera.', {
          toastId: 'camera-not-found',
        });
        // Don't auto-fallback - let user choose another camera
        return null;
      }
    } else {
      // No camera selected - use first available
      camera = cameras[0];
      console.log('📸 No camera selected, using default:', camera.name);
    }

    if (camera) {
      const stream = new LocalVideoStream(camera);
      setSelectedVideoCameraDevice(camera.name);
      console.log('✅ Created LocalVideoStream with camera:', camera.name);

      // Apply video effects after stream is created
      setTimeout(() => {
        applyVideoEffects(appSettings.video);
      }, 100);

      return stream;
    }

    return null;
  };

  const onloadDisplayPreviewOnLoad = () => {
    if (pageIndex > 0) {
      pageSize = 9
    } else {
      pageSize = 8
    }
    if (pageIndex == 0) {
      const filteredArr = clientObjectArr.filter(obj => obj.isAcceptedByAdmin == true && obj.userId != userId);
      if (filteredArr && filteredArr.length > 0) {
        if (filteredArr.length < pageSize) {
          let count = filteredArr.length + 1
          setParticipantCount(count)
          participantCountGlobal = count;
          clientPagingArr = filteredArr;
          setIsShowPaggination(false)
        } else {
          setParticipantCount(pageSize + 1)
          participantCountGlobal = pageSize + 1
          clientPagingArr = filteredArr.slice(0, pageSize);
          if (filteredArr.length > pageSize)
            setIsShowPaggination(true)
        }
        updateCount(participantCountGlobal)
        console.log('------updated ui----', filteredArr)
      } else {
        participantCountGlobal = 0
        setParticipantCount(0)
        updateCount(0)
        clientPagingArr = [];
        setIsShowPaggination(false)

      }
      if (localVideoStream && videoOption && pageIndex === 0) {
        console.log("DisplayLocalVideoStream line number 916 ")
        displayLocalVideoStream({
          localVideoStream,
          localVideoContainerRef,
          displayName,
          userId,
          isAudioOngoingForLocal,
          participantCount: participantCountGlobal,
          isScreenSharing,
        })
      }
    } else {
      changePage();
    }
  };

  const changePage = () => {
    if (pageIndex > 0) {
      pageSize = 9
    } else {
      pageSize = 8
    }
    console.log(pageIndex, ' --paggiStartIndex- ', paggiStartIndex, '-----paggiLastIndex--------', paggiLastIndex)
    clientPagingArr = [];
    const filteredArr = clientObjectArr.filter(obj => obj.isAcceptedByAdmin == true && obj.userId != userId);

    if (pageIndex == 0) {
      // For first page, use slice to ensure exactly pageSize participants
      clientPagingArr = filteredArr.slice(0, pageSize);
      participantCountGlobal = clientPagingArr.length + 1; // +1 for local user
      setParticipantCount(participantCountGlobal);

      // Ensure local video is properly rendered when returning to first page
      if (localVideoStream && videoOption) {
        console.log("Re-rendering local video stream on first page");
        // Small delay to ensure DOM is updated
        setTimeout(() => {
          const localParticipantDetails = getLocalParticipantDetails();
          displayLocalVideoStream({
            localVideoStream,
            localVideoContainerRef,
            displayName,
            userId,
            isAudioOngoingForLocal,
            participantCount: participantCountGlobal,
            isScreenSharing,
            localParticipant: localParticipantDetails,
          });
        }, 100);
      }
    } else {
      // For subsequent pages, use the loop with paggiStartIndex and paggiLastIndex
      try {
        for (let i = paggiStartIndex; i < paggiLastIndex; i++) {
          if (filteredArr[i] && filteredArr[i].displayName)
            clientPagingArr.push(filteredArr[i])
        }
      } catch (error) {
        console.log(error)
      }
      participantCountGlobal = clientPagingArr.length;
      setParticipantCount(clientPagingArr.length);
    }

    console.log(pageIndex, ' --change page- ', participantCountGlobal, clientPagingArr)
    const findLocalUser = clientObjectArr.find((user) => userId === user.userId);
    updateCount(participantCountGlobal)
    if (pageIndex == 0) {
      setDisplayRemoteParticipant([...clientPagingArr, findLocalUser]);
    } else {
      setDisplayRemoteParticipant([...clientPagingArr]);
    }
  }
  const checkIfLobbyExistOrNot = (eventType) => {
    if (isCallCreator.current[userId]) {
      let tempArr = clientObjectArr.filter(obj => obj.isAcceptedByAdmin == false);

      // Only open lobby automatically if there are users waiting OR if it's a manual click
      if (tempArr && tempArr.length > 0) {
        // Auto-open lobby when there are users waiting
        openParticipantPanel('lobby')
        modalRefParticipant.current.update(tempArr);
      } else if (eventType === 'onclick') {
        // Manual click - allow admin to open lobby even when empty
        openParticipantPanel('lobby')
        modalRefParticipant.current.update([]);
      } else if (eventType === 'lobby-join') {
        // Someone just joined the lobby - open it automatically
        openParticipantPanel('lobby')
        modalRefParticipant.current.update(tempArr);
      }
      // If no users waiting and not a manual click, don't open lobby automatically
    }
  }
  const openParticipantPanel = (from) => {
    if (isScreenShotOpen)
      modalRefScreenShot.current.close();
    modalChatRef.current.close();
    visualEffectsPanelRef.current?.close();
    modalRefParticipant.current.open(from);
  }
  const openScreenShotPanel = () => {
    if (isRightPanelOpen)
      modalRefParticipant.current.close();
    modalChatRef.current.close();
    visualEffectsPanelRef.current?.close();
    modalRefScreenShot.current.open();
    modalRefScreenShot.current.update({ progressId, tokenFromAzureLogin });
  }
  const openChatPanel = () => {
    if (isChatPannelOpen)
      modalRefScreenShot.current.close();
    modalRefParticipant.current.close();
    visualEffectsPanelRef.current?.close();
    modalChatRef.current.open();
  }
  const openVisualEffectsPanel = () => {
    closeAllToggles();
    modalRefParticipant.current?.close();
    modalRefScreenShot.current?.close();
    modalChatRef.current?.close();
    visualEffectsPanelRef.current?.open();
  };
  const CbFromParticipant = (data) => {
    console.log(data, '------data.isOpen------', data.isOpen)
    isRightPanelOpenGlobal = data.isOpen;
    setIsRightPanelOpen(data.isOpen)
    isParticipantOpen = false;
    isLobbyOpen = false;
    isScreenShotOpen = false;
    isChatPannelOpen = false;
    isVisualEffectsOpen = false;
    setIsVisualEffectsPanelOpenState(false);
    if (data.from === 'lobby') {
      isLobbyOpen = data.isOpen;
      if (data.reqFordata === 'lobby') {
        checkIfLobbyExistOrNot('onclick');
      }
    } else if (data.from === 'participant') {
      isParticipantOpen = data.isOpen;
      if (data.reqFordata === 'participant') {
        openParticipantList();
      }
    } else if (data.from === 'chat') {
      isChatPannelOpen = data.isOpen;
      if (data.reqFordata === 'chat') {
        openChatPanel();
      }
    } else if (data.from === 'visualEffects') {
      isVisualEffectsOpen = data.isOpen;
      setIsVisualEffectsPanelOpenState(data.isOpen);
    } else {
      isScreenShotOpen = data.isOpen;
    }
  }
  const getLinkAfterCreateRoom = (data) => {
    console.log('-----getLinkAfterCreateRoom---', data)
    acsRoomId = data.acsRoomId
    setAdminLink(data.adminlink)
    setSellerLink(data.sellerLink)
  }
  const startCallOnClick = () => {
    const now = new Date().getTime();
    const now2 = Date.now();
    if (!displayNameUi) {
      alert('Please enter display name')
    }
    else if (isAlreadyJoined) {
      alert('You have already joined in this call')
    }
    else {
      if (isCallCreator.current[userId]) {
        isUserJoinedToRoom = true;
        const tempObj = { userId: userId, userType: isCallCreator.current[userId] ? 'Admin' : 'Other', socketId: socket.id, displayName: displayName, isRiseHand: false, isMute: !micOption, isVideoOff: !videoOption, isAllowRecording: true, recordingStatus: 'init', stream: null, isAllowCamera: true, isAllowMicroPhone: true, isAcceptedByAdmin: isCallCreator.current[userId] ? true : false, uinfo: uinfo, callDurationtTime: '', recordingOnGoingStatus: 'initial' };
        socket.emit('BE-join-room', { acsRoomId, userName: userId, socketId: socket.id, data: tempObj });
        handleJoinRoomCall()
      } else {
        setIsWaitingForApproval(true);
        setDynamicMessage(`You are waiting in the lobby. Please wait for the admin's approval.`)

        // Pre-warm CallClient while waiting in lobby for faster joining
        preWarmCallClient();

        const tempObj = { userId: userId, userType: isCallCreator.current[userId] ? 'Admin' : 'Other', socketId: socket.id, displayName: displayName, isRiseHand: false, isMute: !micOption, isVideoOff: !videoOption, isAllowRecording: false, recordingStatus: 'init', stream: null, isAllowCamera: true, isAllowMicroPhone: true, isAcceptedByAdmin: isCallCreator.current[userId] ? true : false, uinfo: uinfo, callDurationtTime: '', recordingOnGoingStatus: 'initial' };
        socket.emit('BE-join-room', { acsRoomId, userName: userId, socketId: socket.id, data: tempObj }); //click on join call button
      }
    }
  }
  /**
   * Start video using the user's selected camera
   * Uses robust matching to find the correct ACS camera
   * Shows appropriate errors if camera not found or permission denied
   */
  const startVideo = async () => {
    try {
      if (!deviceManager) {
        console.error('DeviceManager not initialized');
        toast.error('Unable to start video. Please try again.', { toastId: 'video-start-error' });
        return;
      }

      const cameras = await deviceManager.getCameras();
      console.log('🎥 Starting video - Available cameras:', cameras.map(c => ({ id: c.id, name: c.name })));

      if (!cameras || cameras.length === 0) {
        console.error('No cameras available');
        toast.error('No camera detected. Please connect a camera to continue.', {
          toastId: 'no-camera-detected',
        });
        setIsVideoOnGoing(false);
        videoOption = false;
        return;
      }

      let camera = null;

      // Use selected video device with robust matching
      if (selectedVideoDevice) {
        console.log('🎯 Starting video with selected camera:', selectedVideoDevice.label || selectedVideoDevice.deviceId);
        camera = findMatchingACSCamera(cameras, selectedVideoDevice);

        if (!camera) {
          console.warn('⚠️ Selected camera not found');
          toast.warning('Selected camera not found. Please select another camera from settings.', {
            toastId: 'camera-not-found',
          });
          setIsVideoOnGoing(false);
          videoOption = false;
          return;
        }
      } else {
        // No specific camera selected - use first available
        camera = cameras[0];
        console.log('📸 No camera selected, using default:', camera.name);
      }

      // Create and start video stream
      const newLocalVideoStream = new LocalVideoStream(camera);
      await call.startVideo(newLocalVideoStream);
      setLocalVideoStream(newLocalVideoStream);
      console.log('✅ Video started with camera:', camera.name);

      // Apply video effects
      setTimeout(() => {
        applyVideoEffects(appSettings.video);
      }, 100);

      // Update clientObjectArr with the new stream
      const ownIndex = clientObjectArr.findIndex(item => item.userId === userId);
      if (ownIndex > -1) {
        clientObjectArr[ownIndex].stream = newLocalVideoStream;
      }

    } catch (error) {
      console.error("Error starting video:", error);

      const errorMessage = error.message || error.toString() || '';

      // Check if it's a permission error
      if (error.name === 'CallingCommunicationError' ||
        errorMessage.includes('permission') ||
        errorMessage.includes('Permission') ||
        errorMessage.includes('permission was not granted')) {
        setPermissionErrorModal({
          isOpen: true,
          deviceType: 'camera'
        });
        setIsVideoOnGoing(false);
        videoOption = false;
      } else if (errorMessage.includes('not found') || errorMessage.includes('NotFoundError')) {
        toast.error('Camera not found. Please check your camera connection.', {
          toastId: 'camera-connection-error',
        });
        setIsVideoOnGoing(false);
        videoOption = false;
      } else {
        toast.error('Unable to start video. Please try again.', {
          toastId: 'video-start-error',
        });
        console.error("Video start error:", error);
      }
    }
  };
  const updateMuteStatusLocal = () => {
    const muteStatusElement = document.getElementById(`mute-status-${userId}`);
    if (muteStatusElement) {
      muteStatusElement.src = isAudioOnGoing ? mute_incall : unmute_incall;
    }
  };
  // Removed updateRiseHandStatusLocal - using React state management instead
  const disconnectCall = (type) => {
    isOwnRemovedFromCall = true;
    isUserJoinedToRoom = false;
    resetVisualEffects();
    call.hangUp();
    setPagenumber(4);
    setDisconnectMessage(type === 'ClickOnDisconnect' ? 'You left the meeting, Thank you for using our video call facility.' : type === 'EndCallByAdmin' ? 'The admin has ended the call.' : type === 'RemoveExistingAddSameUser' ? 'You are trying to join from another device' : 'You were removed from the meeting.')
  }

  const retryCallInitialization = () => {
    setCallInitError(null);
    setIsCallInitializing(true);
    setCallInitMessage(isCallCreator.current[userId] ? 'Setting up your call...' : 'Connecting to the meeting...');
    setTimeout(() => {
      initializeCall();
    }, 1000);
  }

  const handleLeaveWaitingRoom = () => {
    setIsWaitingForApproval(false);
    setPagenumber(2);
    setDynamicMessage('');
    // Notify server that user left the lobby
    socket.emit('BE-leave-lobby', { acsRoomId, userName: userId, socketId: socket.id });
  }

  // Comprehensive rejoin handler - resets all state and prepares for new call
  const handleRejoinCall = useCallback(async () => {
    // Prevent multiple clicks
    if (rejoiningRef.current) {
      console.log('Rejoin already in progress, ignoring click');
      return;
    }
    rejoiningRef.current = true;

    // Show loader immediately
    setIsRejoining(true);

    // Small delay to ensure loader renders before heavy operations
    await new Promise(resolve => setTimeout(resolve, 50));

    try {
      // 1. Stop any ongoing screen share first
      if (call && call.localVideoStreams.length > 0) {
        const screenShareStream = call.localVideoStreams.find(stream =>
          stream.mediaStreamType === 'ScreenSharing' || stream.mediaStreamType === 'RawMedia'
        );
        if (screenShareStream) {
          try {
            await call.stopVideo(screenShareStream);
          } catch (err) {
            console.log('Error stopping screen share:', err);
          }
        }
      }

      // 2. Clean up call object if it exists
      if (call) {
        try {
          const callState = call.state;
          if (callState !== 'Disconnected' && callState !== 'None') {
            await call.hangUp();
          }
        } catch (err) {
          console.log('Call already hung up or error:', err);
        }
        call = null;
      }

      // 3. Clean up device manager before call agent
      if (deviceManager) {
        try {
          // Release all devices
          deviceManager = null; // Azure SDK doesn't have dispose for deviceManager
        } catch (err) {
          console.log('Error cleaning device manager:', err);
        }
      }

      // 4. Clean up call agent if it exists
      if (callAgent) {
        try {
          await callAgent.dispose();
        } catch (err) {
          console.log('Error disposing call agent:', err);
        }
        callAgent = null;
      }

      // 5. Clear intervals
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }

      // 6. Reset global flags and variables
      isOwnRemovedFromCall = false;
      isUserJoinedToRoom = false;
      isParticipantRemoved = false;
      recordingStartBeforeJoining = false;
      selectLanForRecording = '';
      callDurationInSec = 0;
      participantCountGlobal = 1;
      callId = '';
      serverCallId = '';
      screenSharerUserId = null;

      // 7. Reset arrays and pagination
      clientObjectArr = [];
      clientPagingArr = [];
      pageIndex = 0;
      paggiStartIndex = 0;
      paggiLastIndex = pageSize;

      // 8. Reset panel states
      isParticipantOpen = false;
      isScreenShotOpen = false;
      isLobbyOpen = false;
      isRightPanelOpenGlobal = false;
      isChatPannelOpen = false;

      // 9. Reset pre-warmed client to force fresh initialization
      preWarmedCallClient = null;
      isPreWarmingInProgress = false;

      // 10. Clean up local video stream
      if (localVideoStream) {
        try {
          if (typeof removeLocalVideoStream === 'function') {
            removeLocalVideoStream();
          }
        } catch (err) {
          console.log('Error cleaning up local video stream:', err);
        }
      }

      // 11. Reset ALL React state variables
      setLocalVideoStream(null);
      setDisplayRemoteParticipant([]);
      setIsShowPaggination(false);
      setParticipantCount(1);
      setIsAlreadyJoined(false);
      setIsWaitingForApproval(false);
      setRecordingStatus('initial');
      setRecordingInitiatorId(null);
      setIsRecordingConsentRequested(false);
      setRiseHandActiveStatus(false);
      setIsRiseHandLoading(false);
      setLastRiseHandClick(0);
      setIsScreenShared(false);
      setIsVideoOnGoing(true);
      setIsAudioOnGoing(true);
      setIsNextBtnActive(true);
      setTotalUnreadMessageCount(0);
      setCallDuration('00:00:00');
      setDynamicMessage('');
      setIsRecordingModal(false);
      setAdminListModel(false);
      setRecordingTransferModel(false);
      setIsRequestedModalOpen(false);
      setIsLanguageModal(false);
      setIsRightPanelOpen(false);
      setIsScreenSharePermissionModalOpen(false);
      setScreenShareRequestData(null);
      setRequestedAccessName('');
      setRequesterName('');
      setAdminId('');
      setOpenScreenShotMenuList(false);
      setMicrophoneDropdownOpen(false);
      setCameraDropdownOpen(false);
      setLoading(false);
      setIsCallInitializing(false);
      setCallInitError(null);
      setCallInitMessage('');
      setIsMenuListOpen(false);
      setIsThemeOpen(false);

      // 12. Reset preJoinSettings to default
      setPreJoinSettings({
        video: false,
        audio: false,
        selectedAudioDevice: null,
        selectedVideoDevice: null
      });

      // 13. Synchronize global variables with React state
      micOption = false;
      videoOption = false;
      isAudioOngoingForLocal = true;

      // 14. Stop recording timer if running
      if (isTimerRunning) {
        stopRecordingTimer();
      }

      // 15. Clear any pending timeouts
      if (callInitTimeoutRef.current) {
        clearTimeout(callInitTimeoutRef.current);
        callInitTimeoutRef.current = null;
      }

      if (riseHandTimeoutRef.current) {
        clearTimeout(riseHandTimeoutRef.current);
        riseHandTimeoutRef.current = null;
      }

      // 16. Clear toast notifications
      toastQueue.clearAll();

      // 17. Notify server that user is leaving before rejoining (cleanup)
      if (socket && socket.connected && acsRoomId && userId) {
        // Create a promise to wait for server acknowledgment
        const serverCleanupPromise = new Promise((resolve) => {
          // Set a timeout in case server doesn't respond
          const timeoutId = setTimeout(() => {
            console.log('Server cleanup timeout, proceeding anyway');
            resolve();
          }, 2000); // 2 second timeout

          // Listen for acknowledgment (you may need to add this event handler on server)
          const cleanupHandler = () => {
            clearTimeout(timeoutId);
            socket.off('FE-cleanup-acknowledged', cleanupHandler);
            resolve();
          };
          socket.once('FE-cleanup-acknowledged', cleanupHandler);

          // Send cleanup request
          socket.emit('BE-update-status', {
            acsRoomId: acsRoomId,
            senderUserId: userId,
            socketId: socket.id,
            data: null,
            type: 'CleanupBeforeRejoin',
            typeValue: true
          });
        });

        // Wait for server acknowledgment or timeout
        await serverCleanupPromise;
      }

      // 18. Small delay to ensure all cleanup is complete
      await new Promise(resolve => setTimeout(resolve, 100));

      // 19. Go back to pre-join screen
      setPagenumber(2);

      // 20. Reset rejoin flag and hide loader
      rejoiningRef.current = false;
      setIsRejoining(false);

    } catch (error) {
      console.error('❌ Error during rejoin preparation:', error);
      errorToast.error('Error preparing to rejoin. Please try refreshing the page.');

      // Reset flags and hide loader on error
      rejoiningRef.current = false;
      setIsRejoining(false);
    }
  }, [
    localVideoStream,
    isTimerRunning,
    stopRecordingTimer,
    setPagenumber,
    setDisplayRemoteParticipant,
    setParticipantCount,
    setIsAlreadyJoined,
    setIsWaitingForApproval,
    setRecordingStatus,
    setRecordingInitiatorId,
    setRiseHandActiveStatus,
    setIsRiseHandLoading,
    setLastRiseHandClick,
    setIsScreenShared,
    setIsVideoOnGoing,
    setIsAudioOnGoing,
    setIsNextBtnActive,
    setTotalUnreadMessageCount,
    setCallDuration,
    setDynamicMessage,
    setIsShowPaggination,
    setLocalVideoStream,
    setIsRejoining,
    setIsRecordingModal,
    setAdminListModel,
    setRecordingTransferModel,
    setIsRequestedModalOpen,
    setIsLanguageModal,
    setIsRightPanelOpen,
    setIsScreenSharePermissionModalOpen,
    setScreenShareRequestData,
    setRequestedAccessName,
    setRequesterName,
    setAdminId,
    setOpenScreenShotMenuList,
    setMicrophoneDropdownOpen,
    setCameraDropdownOpen,
    setLoading,
    setIsCallInitializing,
    setCallInitError,
    setCallInitMessage,
    setIsMenuListOpen,
    setIsThemeOpen,
    setPreJoinSettings,
    socket,
    acsRoomId,
    userId
  ]);
  const openParticipantList = () => {
    modalRefParticipant.current.updateUnnamedFlag(isUnmannedUser);
    let tempArr = clientObjectArr.filter(obj => obj.isAcceptedByAdmin == true);
    openParticipantPanel('participant')
    modalRefParticipant.current.update(tempArr);
  }
  const evaluateRecordingConsentState = () => {
    const consentParticipants = clientObjectArr.filter(obj => obj.isAcceptedByAdmin == true && obj.userId !== userId);

    if (consentParticipants.length === 0) {
      setIsRecordingConsentRequested(false);
      return;
    }

    const hasPending = consentParticipants.some(obj => !obj.recordingStatus || obj.recordingStatus === 'init');
    if (hasPending) {
      setIsRecordingConsentRequested(true);
      return;
    }

    const allRejected = consentParticipants.every(obj => obj.recordingStatus === 'reject');
    if (allRejected) {
      setIsRecordingConsentRequested(false);
      return;
    }

    const allAccepted = consentParticipants.every(obj => obj.isAllowRecording);
    if (allAccepted) {
      setIsRecordingConsentRequested(false);
      return;
    }

    setIsRecordingConsentRequested(true);
  };

  const resendRecordingPermission = (participantId, options = {}) => {
    let participantName = '';
    for (let i = 0; i < clientObjectArr.length; i++) {
      if (clientObjectArr[i].userId == participantId) {
        participantName = clientObjectArr[i].displayName || '';
        clientObjectArr[i].isAllowRecording = false;
        clientObjectArr[i].recordingStatus = 'init';
      }
    }

    const tempObj = { userId: participantId, userType: 'Admin', socketId: socket.id, displayName: displayName, recordingStatus: 'start' };

    socket.emit("BE-update-status", {
      acsRoomId: acsRoomId,
      senderUserId: participantId,
      socketId: socket.id,
      data: tempObj,
      type: "adminResendRecordingRequest",
      typeValue: true
    });

    evaluateRecordingConsentState();

    if (modalRefParticipant.current) {
      const filteredArr = clientObjectArr.filter(obj => obj.isAcceptedByAdmin == true && obj.userId != userId);
      modalRefParticipant.current.update(filteredArr);
      if (!options?.silent) {
        if (participantName) {
          modalRefParticipant.current.updateDynamicMsg(`Consent request resent to ${participantName}`);
        } else {
          modalRefParticipant.current.updateDynamicMsg('Consent request resent.');
        }
      }
    }
  };

  const resendRecordingPermissionForDenied = () => {
    const deniedParticipants = clientObjectArr.filter(obj => obj.isAcceptedByAdmin == true && obj.userId !== userId && obj.recordingStatus === 'reject');

    if (!deniedParticipants.length) {
      return;
    }

    deniedParticipants.forEach(participant => {
      resendRecordingPermission(participant.userId, { silent: true });
    });

    if (modalRefParticipant.current) {
      const count = deniedParticipants.length;
      const label = count === 1 ? 'participant' : 'participants';
      modalRefParticipant.current.updateDynamicMsg(`Consent request resent to ${count} denied ${label}.`);
    }
  };

  const openParticipantListForRecording = async () => {
    if (recordingStatus === 'initial') { // starting the recording
      // Always reset consent state for all participants - fresh consent required every time
      for (let i = 0; i < clientObjectArr.length; i++) {
        clientObjectArr[i].isAllowRecording = false;
        clientObjectArr[i].recordingStatus = 'init';
      }

      const filteredArr = clientObjectArr.filter(obj => obj.isAcceptedByAdmin == true && obj.userId != userId);

      setDynamicMessage('')

      // Set consent requested flag
      setIsRecordingConsentRequested(true);

      const tempObj = { userId: userId, userType: 'Admin', socketId: socket.id, displayName: displayName, recordingStatus: 'start' };
      socket.emit('BE-update-status', { acsRoomId: acsRoomId, senderUserId: userId, socketId: socket.id, data: tempObj, type: 'adminWantsToRecord', typeValue: true });
      // modalRefParticipant.current.open('participantForRecording');
      openParticipantPanel('participantForRecording')
      modalRefParticipant.current.update(filteredArr);

      evaluateRecordingConsentState();

    } else if (recordingStatus === 'starting') { // pause the recording
      let pauseObj = await pauseRecording()
      console.log('----pauseObj----', pauseObj)
      if (pauseObj?.recordingId) {
        setRecordingStatus('paused');
        socket.emit('BE-update-status', { acsRoomId: acsRoomId, senderUserId: userId, socketId: socket.id, data: { isSuccessMsg: false, status: 'RecordingPaused' }, type: 'BroadCastMessage', typeValue: 'Recording Paused' });
        modalRefParticipant.current.updateRecordingFlag('paused');
      }
    } else if (recordingStatus === 'paused') { // pause the recording
      let resumeObj = await ResumeRecording()
      console.log('----resumeObj----', resumeObj)
      if (resumeObj?.recordingId) {
        setRecordingStatus('starting');
        socket.emit('BE-update-status', { acsRoomId: acsRoomId, senderUserId: userId, socketId: socket.id, data: { isSuccessMsg: true, status: 'RecordingResume' }, type: 'BroadCastMessage', typeValue: 'Recording Resumed' });
        modalRefParticipant.current.updateRecordingFlag('started');
      }
    }
  }

  const layoutClass = useCallback(() => {
    const currentScreenShareItem = displayRemoteParticipant.find(item => item.isScreenShare);
    if (currentScreenShareItem) {
      return "";
    }
    let gridClass = "_" + (participantCount) + "GridLayout";
    if (pageIndex > 0) {
      gridClass = gridClass + " nextPage"
    }
    return gridClass;
  }, [displayRemoteParticipant, participantCount, pageIndex]);

  const prevPaggination = () => {
    if (pageIndex > 0) {
      pageIndex--
      paggiStartIndex = pageIndex * pageSize;
      paggiLastIndex = pageIndex === 0 ? pageSize : paggiStartIndex + pageSize;
      changePage() // Use changePage instead of onloadDisplayPreviewOnLoad for consistent pagination
      setIsNextBtnActive(true)
    } else {
      infoToast.info('You are on the first page');
    }
  }
  const nextPaggination = () => {
    const filteredArr = clientObjectArr.filter(obj => obj.isAcceptedByAdmin == true && obj.userId != userId);
    let pSize = parseInt((filteredArr.length) / pageSize);
    let remainingItem = (filteredArr.length) % pageSize
    if (remainingItem == 0)
      pSize = pSize - 1;
    console.log(pageSize, 'onclick --', filteredArr.length, pSize, remainingItem)
    if (pageIndex < pSize || (pageIndex < pSize && remainingItem > 0)) {
      pageIndex++
      console.log('inside if --', pageIndex, pageSize)
      paggiStartIndex = pageIndex * pageSize;
      pageSize = 9;
      paggiLastIndex = paggiStartIndex + pageSize;
      changePage() // Use changePage instead of onloadDisplayPreviewOnLoad for consistent pagination

    } else {
      infoToast.info('You are on the last page');
    }

    if (pageIndex < pSize || (pageIndex < pSize && remainingItem > 0)) {
      setIsNextBtnActive(true)
    } else {
      setIsNextBtnActive(false)
    }

  }

  const openAndRefreshList = () => { //callback after taking screen shot
    openScreenShotPanel()
    socket.emit('BE-update-status', { acsRoomId: acsRoomId, senderUserId: userId, socketId: socket.id, data: { isSuccessMsg: true, status: 'TakenScreenShot' }, type: 'BroadCastMessage', typeValue: `${displayName} captured the screenshot` });
  }

  const clickOnVideoIcon = useCallback(async () => {
    const tempObj = { userId: userId, userType: isCallCreator.current[userId] ? 'Admin' : 'Other', socketId: socket.id, displayName: displayName, isRiseHand: isVideoOnGoing };

    if (videoOption) {
      // Turning video OFF
      socket.emit('BE-update-status', { acsRoomId: acsRoomId, senderUserId: userId, socketId: socket.id, data: tempObj, type: 'updateVideoOnOff', typeValue: isVideoOnGoing });

      const localVideoStream = call.localVideoStreams.find((stream) => { return stream.mediaStreamType === 'Video' });
      if (localVideoStream) {
        await call?.stopVideo(localVideoStream);
      }
      await resetVisualEffects();
      setLocalVideoStream(null);

      // Set stream to null in clientObjectArr when video is turned off
      let ownIndex = clientObjectArr.findIndex(item => item.userId === userId);
      if (ownIndex > -1) {
        clientObjectArr[ownIndex].stream = null;
      }

      setTimeout(() => {
        setIsVideoOnGoing(false);
        videoOption = false;
        onloadDisplayPreviewOnLoad();
      }, 300);
    } else {
      // Turning video ON - validate camera first
      const cameraValid = await validateSelectedCamera();

      if (!cameraValid) {
        // Camera not available - don't proceed
        console.log('❌ Cannot start video - no valid camera available');
        return;
      }

      // Emit status update before starting
      socket.emit('BE-update-status', { acsRoomId: acsRoomId, senderUserId: userId, socketId: socket.id, data: tempObj, type: 'updateVideoOnOff', typeValue: isVideoOnGoing });

      await startVideo();

      setTimeout(() => {
        setIsVideoOnGoing(true);
        videoOption = true;
        onloadDisplayPreviewOnLoad();
      }, 300);
    }
  }, [userId, isVideoOnGoing, acsRoomId, call, displayName, resetVisualEffects, startVideo, validateSelectedCamera]);

  const clickOnMuteUnmuteIcon = useCallback(() => {
    console.log('clickOnMuteUnmuteIcon called, current isAudioOnGoing:', isAudioOnGoing);
    const tempObj = { userId: userId, userType: isCallCreator.current[userId] ? 'Admin' : 'Other', socketId: socket.id, displayName: displayName, isRiseHand: isAudioOnGoing };
    socket.emit('BE-update-status', { acsRoomId: acsRoomId, senderUserId: userId, socketId: socket.id, data: tempObj, type: 'updateMuteUnmute', typeValue: isAudioOnGoing });

    if (isAudioOnGoing) {
      console.log('Muting call...');
      call.mute();
    } else {
      console.log('Unmuting call...');
      call.unmute();
    }

    isAudioOngoingForLocal = !isAudioOnGoing;
    updateMuteStatusLocal()
    setIsAudioOnGoing(!isAudioOnGoing);
    console.log('Audio state changed to:', !isAudioOnGoing);
  }, [userId, isAudioOnGoing, acsRoomId, call, displayName]);

  const clickOnDisconnectIcon = useCallback((from) => {
    socket.emit('BE-update-status', { acsRoomId: acsRoomId, senderUserId: userId, socketId: socket.id, data: null, type: from, typeValue: true });
    if (isCallCreator.current[userId] && recordingStatus !== 'initial') {
      recordingToast.error('Recording will save automatically')
    }
  }, [acsRoomId, userId, recordingStatus]);

  const handleLeaveMeetingSelection = () => {
    closeAllToggles();
    setIsEndCallDropdownOpen(false);

    if (isCallCreator.current[userId]) {
      const checkMultipleAdmins = clientObjectArr.filter(item => item?.userType === 'Admin');

      isModalFor = 'EndCall';
      setEndCallModalIntent('leave');

      if (checkMultipleAdmins.length > 1 && recordingStatus === 'starting') {
        setRecordingTransferModel(true);
      } else {
        setIsRecordingModal(true);
      }
    } else {
      clickOnDisconnectIcon('ClickOnDisconnect');
      disconnectCall('ClickOnDisconnect');
    }
  };

  const handleEndMeetingSelection = () => {
    closeAllToggles();
    setIsEndCallDropdownOpen(false);

    if (!isCallCreator.current[userId]) {
      clickOnDisconnectIcon('ClickOnDisconnect');
      disconnectCall('ClickOnDisconnect');
      return;
    }

    const checkMultipleAdmins = clientObjectArr.filter(item => item?.userType === 'Admin');
    isModalFor = 'EndCall';
    setEndCallModalIntent(null);

    if (checkMultipleAdmins.length > 1 && recordingStatus === 'starting') {
      setRecordingTransferModel(true);
    } else {
      setIsRecordingModal(true);
    }
  };


  const clickOnRiseHandIcon = useCallback(() => {
    try {
      // Close all open menus
      closeAllToggles();

      const now = Date.now();

      // Debouncing: Prevent rapid clicks (500ms debounce)
      if (now - lastRiseHandClick < 500) {
        return;
      }
      setLastRiseHandClick(now);

      // Prevent multiple rapid clicks
      if (isRiseHandLoading) {
        return;
      }

      // Add validation
      if (!socket || !socket.connected) {
        errorToast.error("Connection lost. Please check your network and try again.");
        return;
      }

      if (!isUserJoinedToRoom) {
        errorToast.warning("You must be in the meeting to raise your hand.");
        return;
      }

      // Clear any existing timeout
      if (riseHandTimeoutRef.current) {
        clearTimeout(riseHandTimeoutRef.current);
        riseHandTimeoutRef.current = null;
      }

      // Set loading state
      setIsRiseHandLoading(true);

      // Create temp object for server
      const tempObj = {
        userId: userId,
        userType: isCallCreator.current[userId] ? 'Admin' : 'Other',
        socketId: socket.id,
        displayName: displayName,
        isRiseHand: !riseHandActiveStatus
      };

      // Emit to server - let server response handle state updates
      socket.emit('BE-update-status', {
        acsRoomId: acsRoomId,
        senderUserId: userId,
        socketId: socket.id,
        data: tempObj,
        type: 'updateRiseHand',
        typeValue: !riseHandActiveStatus
      });

      // Fixed timeout: Use ref to avoid closure issues
      riseHandTimeoutRef.current = setTimeout(() => {
        setIsRiseHandLoading(prevLoading => {
          if (prevLoading) { // Only show error if still loading
            errorToast.error("Request timed out. Please try again.");
            return false;
          }
          return prevLoading;
        });
        riseHandTimeoutRef.current = null;
      }, 5000);
    } catch (error) {
      console.error('Error in clickOnRiseHandIcon:', error);
      errorToast.error("Failed to raise hand. Please try again.");
      setIsRiseHandLoading(false);

      // Clear timeout on error
      if (riseHandTimeoutRef.current) {
        clearTimeout(riseHandTimeoutRef.current);
        riseHandTimeoutRef.current = null;
      }
    }
  }, [userId, riseHandActiveStatus, acsRoomId, displayName, socket, isUserJoinedToRoom, isRiseHandLoading, lastRiseHandClick]);

  // Cleanup timeout on component unmount
  useEffect(() => {
    return () => {
      if (riseHandTimeoutRef.current) {
        clearTimeout(riseHandTimeoutRef.current);
        riseHandTimeoutRef.current = null;
      }
    };
  }, []);

  // Handle recording timer based on recording status
  useEffect(() => {
    if (recordingStatus === 'starting' || recordingStatus === 'started') {
      // Only start if not already running, otherwise resume
      if (!isTimerRunning) {
        startRecordingTimer();
      } else if (isTimerPaused) {
        // Resume from pause
        resumeRecordingTimer();
      }
    } else if (recordingStatus === 'paused') {
      pauseRecordingTimer();
    } else if (recordingStatus === 'initial') {
      stopRecordingTimer();
    }
  }, [recordingStatus, startRecordingTimer, pauseRecordingTimer, resumeRecordingTimer, stopRecordingTimer, isTimerRunning, isTimerPaused]);

  // Handle recording timer synchronization
  useEffect(() => {
    if (!socket) return;

    // Listen for timer updates from server
    const handleTimerUpdate = ({ acsRoomId: roomId, timerState, adminUserId, timestamp }) => {
      if (roomId === acsRoomId && adminUserId !== userId) {
        // Sync with external timer state (only if not the admin who made the change)
        syncWithExternalState(timerState);
      }
    };

    // Listen for timer sync response
    const handleTimerSync = ({ acsRoomId: roomId, timerState, elapsedTime, timestamp }) => {
      if (roomId === acsRoomId) {
        // Sync with server timer state
        syncWithExternalState(timerState);
      }
    };

    socket.on('FE-recording-timer-update', handleTimerUpdate);
    socket.on('FE-recording-timer-sync', handleTimerSync);

    // Request timer sync when joining (for new users or rejoiners)
    if (acsRoomId && userId) {
      requestSync();
    }

    return () => {
      socket.off('FE-recording-timer-update', handleTimerUpdate);
      socket.off('FE-recording-timer-sync', handleTimerSync);
    };
  }, [socket, acsRoomId, userId, syncWithExternalState, requestSync]);

  // Function to ensure local user's raise hand element exists
  const ensureLocalRaiseHandElement = useCallback(() => {
    const localRaiseHandElement = document.getElementById(`risehand-status-${userId}`);
    if (!localRaiseHandElement) {
      console.log(`🖐️ Local user's raise hand element not found, creating it`);
      const className = getClassName(participantCountGlobal, isRightPanelOpen, pinnedParticipantId);
      console.log('----className----', className)
      // Find the local video container
      const localContainer = document.querySelector(className) ||
        document.querySelector('[data-local-video]') ||
        document.querySelector('.local-video-container') ||
        document.querySelector('.video-container');

      console.log('----localContainer----', localContainer)

      if (localContainer) {
        const risehandStatusElement = document.createElement("img");
        risehandStatusElement.className = "risehand-status";
        risehandStatusElement.src = raise_hand_svg;
        risehandStatusElement.style.display = "none";
        risehandStatusElement.id = `risehand-status-${userId}`;
        localContainer.appendChild(risehandStatusElement);
        console.log(`🖐️ Created local user's raise hand element`);
        return risehandStatusElement;
      } else {
        console.error(`❌ Local video container not found`);
        return null;
      }
    }
    return localRaiseHandElement;
  }, [userId]);

  // Picture-in-Picture functionality
  const {
    isPiPActive,
    isPiPSupported,
    isPiPLoading,
    enterPiP,
    exitPiP,
    togglePiP,
    forceExitPiP,
    getPiPVideoElement,
    isVideoInPiP,
    checkAndFixPiPBlocking,
    setPiPCallbacks,
    updatePiPButtonStates,
    updatePiPVideoStream
  } = usePictureInPicture(localVideoStream, isVideoOnGoing, displayNameUi);

  // Handle PiP control actions
  const handlePiPMuteToggle = useCallback(() => {
    console.log('handlePiPMuteToggle called, current isAudioOnGoing:', isAudioOnGoing);
    clickOnMuteUnmuteIcon();
  }, [clickOnMuteUnmuteIcon, isAudioOnGoing]);

  const handlePiPVideoToggle = useCallback(() => {
    clickOnVideoIcon();
  }, [clickOnVideoIcon]);

  const handlePiPExit = useCallback(async () => {
    await exitPiP();
  }, [exitPiP]);

  // Picture-in-Picture toggle function
  const handlePiPToggle = useCallback(async () => {
    if (!isPiPSupported) {
      errorToast.error('Picture-in-Picture is not supported in this browser');
      return;
    }

    // Try to find the local video element if present
    const localVideoElement = localVideoContainerRef.current?.querySelector('video') || null;

    if (localVideoElement) {
      checkAndFixPiPBlocking(localVideoElement);
      await togglePiP(localVideoElement);
    } else {
      // Allow Document PiP without a video element (will show camera-off UI)
      await togglePiP(null);
    }
  }, [isPiPSupported, togglePiP, checkAndFixPiPBlocking, localVideoContainerRef]);

  // Set up PiP callbacks
  useEffect(() => {
    setPiPCallbacks(handlePiPMuteToggle, handlePiPVideoToggle, handlePiPExit);
  }, [setPiPCallbacks, handlePiPMuteToggle, handlePiPVideoToggle, handlePiPExit]);

  // Update PiP states and video stream when changes occur
  useEffect(() => {
    if (!isPiPActive) return;

    // Update button states immediately when mic/video state changes
    updatePiPButtonStates(!isAudioOnGoing, !isVideoOnGoing);

    // Update video stream immediately
    updatePiPVideoStream();
  }, [isPiPActive, isAudioOnGoing, isVideoOnGoing, updatePiPButtonStates, updatePiPVideoStream]);

  // Separate effect for periodic stream check (only when needed)
  useEffect(() => {
    if (!isPiPActive || !isVideoOnGoing) return;

    // Periodic refresh only when video is on (to catch stream changes)
    // Run less frequently to reduce overhead
    const interval = setInterval(() => {
      updatePiPVideoStream();
    }, 10000); // Check every 10 seconds (reduced from 3s)

    return () => clearInterval(interval);
  }, [isPiPActive, isVideoOnGoing, updatePiPVideoStream]);

  // Cleanup PiP on component unmount
  useEffect(() => {
    return () => {
      if (isPiPActive) {
        forceExitPiP();
      }
    };
  }, [isPiPActive, forceExitPiP]);

  // Update disconnect function to exit PiP
  const clickOnDisconnectIconWithPiP = useCallback((from) => {
    if (isPiPActive) {
      forceExitPiP();
    }
    clickOnDisconnectIcon(from);
  }, [isPiPActive, forceExitPiP, clickOnDisconnectIcon]);

  const renderRecordingButton = useCallback(() => {
    if (!isUserCallCreator || isUnmannedUser) return null;

    return (
      // <span data-title={recordingStatus === 'initial' ? "Call Recording" : recordingStatus === 'paused' ? 'Resume Recording' : 'Pause Recording'}>
      //   <img
      //     src={recordingStatus === 'initial' ? recording_start : recordingStatus === 'paused' ? recording_resume : recording_pause}
      //     alt="Description"
      //     onClick={() => {
      //       openParticipantListForRecording();
      //     }}
      //     className='video-cotrol-btn'
      //   />
      // </span>
      <div className='item'>
        <img src={recordingIcon} alt='recording' className='menuIcon' onClick={() => { openParticipantListForRecording() }} />
        Start Recording
      </div>
    );
  }, [isUserCallCreator, isUnmannedUser, recordingStatus, openParticipantListForRecording]);

  const renderRecordingStatusIndicator = useCallback(() => {
    if (recordingStatus === 'started' && !recordingStartBeforeJoining) {
      recordingToast.success('Recording is already in progress. You will be included in the recording.');
    }

    if (isUserCallCreator || isUnmannedUser || !(recordingStatus === 'started' || recordingStatus === 'paused')) return null;

    return (
      <span data-title={recordingStatus === 'started' ? "Recording on" : 'Recording Paused'}>
        <img
          src={recordingStatus === 'started' ? recording_start : recording_pause}
          className='video-cotrol-btn'
        />
      </span>
    );
  }, [isUserCallCreator, isUnmannedUser, recordingStatus]);

  // Handler to show stop recording confirmation modal
  const handleStopRecordingClick = useCallback(() => {
    isModalFor = 'StopRecording';
    setIsRecordingModal(true);
  }, []);

  const renderStopRecordingButton = useCallback(() => {
    if (!isUserCallCreator || isUnmannedUser || recordingStatus === 'initial') return null;

    return (
      <span data-title='Stop Recording'>
        <img
          src={record_stop}
          alt="Description"
          onClick={handleStopRecordingClick}
          style={{ height: 40, width: 40, resizeMode: 'contain', cursor: 'pointer', marginLeft: 15 }}
        />
      </span>
    );
  }, [isUserCallCreator, isUnmannedUser, recordingStatus, handleStopRecordingClick]);

  const renderScreenshotDropdown = useCallback(() => {
    if (!isUserCallCreator || isUnmannedUser) return null;

    return (
      <div className="dropdown">
        <img
          src={screen_shot}
          alt="Description"
          style={{ height: 40, width: 40, resizeMode: 'contain', cursor: 'pointer', marginLeft: 15 }}
        />
        <ul className="dropdown-menu">
          <li onClick={() => {
            takeScreenShot({ uinfo, ToCaptureRef, tokenFromAzureLogin, toast, openAndRefreshList })
          }}>
            <span>Take Screenshot</span>
          </li>
          <li onClick={() => {
            openScreenShotPanel()
            infoToast.info('Fetching data, Please Wait...')
            setTimeout(() => {
              toast.dismiss()
            }, 2000)
          }}>
            <span>View Screenshot</span>
          </li>
        </ul>
      </div>
    );
  }, [isUserCallCreator, isUnmannedUser, takeScreenShot, uinfo, ToCaptureRef, tokenFromAzureLogin, toast, openAndRefreshList, openScreenShotPanel]);
  const onSelectLanguage = (data) => {
    setIsLanguageModal(false);
    selectLanForRecording = data.slectLan;
    if (data.action === 'yes') {
      startRecordingFromUi(data.slectLan)
    }
  }



  const updateScreenShareView = useCallback(() => {
    if (!call) return;

    const { screenShareStream, screenShareParticipant } = getActiveScreenShareStream(call, userId, displayNameUi);

    if (screenShareStream) {
      const baseParticipants = [...clientPagingArr];
      const updatedList = addScreenShareToParticipants(
        baseParticipants,
        screenShareStream,
        screenShareParticipant ? screenShareParticipant.displayName : 'Screen Share'
      );
      setDisplayRemoteParticipant(updatedList);
    } else {
      const baseParticipants = [...clientPagingArr];
      const updatedList = addScreenShareToParticipants(baseParticipants, null);
      setDisplayRemoteParticipant(updatedList);

      if (call.localVideoStreams && call.localVideoStreams.length > 0) {
        const cameraStream = call.localVideoStreams.find(s => s.mediaStreamType === 'Video');

        if (cameraStream && isVideoOnGoing) {
          setLocalVideoStream(cameraStream);

          const renderLocalVideoWithRetry = (retryCount = 0) => {
            if (!localVideoContainerRef || !localVideoContainerRef.current) {
              if (retryCount < 5) {
                setTimeout(() => renderLocalVideoWithRetry(retryCount + 1), 100);
              }
              return;
            }
            if (videoOption) {
              localVideoContainerRef.current.innerHTML = '';

              const localParticipantDetails = getLocalParticipantDetails();
              displayLocalVideoStream({
                localVideoStream: cameraStream,
                localVideoContainerRef,
                displayName,
                userId,
                isAudioOngoingForLocal,
                participantCount: participantCountGlobal,
                isScreenSharing,
                localParticipant: localParticipantDetails,
              });
            }
          };

          renderLocalVideoWithRetry();
        } else if (localVideoContainerRef.current) {
          localVideoContainerRef.current.innerHTML = '';
          setLocalVideoStream(null);

          // When video is off, call removeLocalVideoStream to create the custom container
          const localParticipantDetails = getLocalParticipantDetails();
          removeLocalVideoStream({
            localVideoContainerRef,
            participantCount,
            participantCountGlobal,
            isRightPanelOpen,
            isAudioOngoingForLocal,
            userId,
            displayName,
            localParticipant: localParticipantDetails,
          });
        }
      } else {
        setLocalVideoStream(null);
        if (localVideoContainerRef.current) {
          localVideoContainerRef.current.innerHTML = '';

          // When no video streams, call removeLocalVideoStream to create the custom container
          const localParticipantDetails = getLocalParticipantDetails();
          removeLocalVideoStream({
            localVideoContainerRef,
            participantCount,
            participantCountGlobal,
            isRightPanelOpen,
            isAudioOngoingForLocal,
            userId,
            displayName,
            localParticipant: localParticipantDetails,
          });
        }
      }
    }
  }, [call, userId, displayNameUi, clientPagingArr, isVideoOnGoing, localVideoContainerRef, displayName, isAudioOngoingForLocal, participantCountGlobal, isScreenSharing]);

  const screenShareItem = displayRemoteParticipant.find(item => item.isScreenShare);
  const participantItems = displayRemoteParticipant.filter(item => !item.isScreenShare);

  const toggleMenuList = (e) => {
    if (e) e.stopPropagation();

    // If already open, just close it
    if (isMenuListOpen) {
      setIsMenuListOpen(false);
    } else {
      // Close all other toggles first
      closeAllToggles();
      // Open menu list
      setIsMenuListOpen(true);
    }
  }

  const toggleTheme = (e) => {
    if (e) e.stopPropagation();

    // If already open, just close it
    if (isThemeOpen) {
      setIsThemeOpen(false);
    } else {
      // Close all other toggles first
      closeAllToggles();
      // Open theme menu
      setIsThemeOpen(true);
    }
  }

  const switchToDarkTheme = () => {
    setDarkTheme();
    setIsThemeOpen(false);
  }

  const switchToLightTheme = () => {
    setLightTheme();
    setIsThemeOpen(false);
  }

  const toggleScreenShotMenuList = (e) => {
    if (e) e.stopPropagation();

    // If already open, just close it
    if (openScreenShotMenuList) {
      setOpenScreenShotMenuList(false);
    } else {
      // Close all other toggles first
      closeAllToggles();
      // Open screenshot menu list
      setOpenScreenShotMenuList(true);
    }
  }


  return (
    <div className="App">
      <ToastContainer position="top-right"
        autoClose={3000}
        hideProgressBar={true}
        theme="colored"
        limit={1}
        newestOnTop={true} />

      {/* Call Initialization Loader */}
      {isCallInitializing && (
        <div className={`call-init-loader-overlay ${isDarkTheme ? 'dark' : ''}`}>
          <div className="call-init-loader-content">
            {callInitError ? (
              <div className="call-init-error">
                <div className="error-icon">⚠️</div>
                <h3>Connection Failed</h3>
                <p>{callInitError}</p>
                <button
                  className="retry-button"
                  onClick={retryCallInitialization}
                >
                  Try Again
                </button>
              </div>
            ) : (
              <Loader message={callInitMessage} />
            )}
          </div>
        </div>
      )}

      <div style={{ display: 'flex', flex: 1, flexDirection: 'column', }}>
        {pagenumber == 0 ? <Loader message="" /> :
          pagenumber == 1 ? <HomeScreen
            userId={userId}
            getLinkAfterCreateRoom={getLinkAfterCreateRoom}
            adminLink={adminLink}
            sellerLink={sellerLink}
          /> :
            pagenumber == 2 ?
              // <div style={{ display: 'flex', flex: 1, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100vh' }}>
              //   {/* -------------page 2---------- */}
              //   {!isCallCreator.current[userId] ? <p style={{ fontSize: 20, color: 'red' }}>{dynamicMessage}</p> : null}
              //   <p className="txtstyle">Display Name </p>
              //   <input className="inputstyle" readOnly
              //     type="text"
              //     placeholder="Enter display name"
              //     value={displayNameUi}
              //     onChange={(e) => {
              //       displayName = e.target.value
              //       setDisplayNameUi(e.target.value)
              //     }}
              //   />


              //   <img src={isCallCreator.current[userId] ? callbtn : join_call} alt="Description" onClick={() => {
              //     startCallOnClick();
              //   }}
              //     style={{ width: 140, resizeMode: 'contain', cursor: 'pointer', marginTop: '2%', opacity: isAlreadyJoined ? .2 : 1 }} />

              // </div> 
              isWaitingForApproval ? (
                <WaitingRoomScreen
                  onLeave={handleLeaveWaitingRoom}
                  participantName={displayNameUi}
                />
              ) : (
                <PreJoinMeetingScreen
                  displayName={displayNameUi}
                  isCallCreator={isCallCreator.current[userId]}
                  startCallOnClick={startCallOnClick}
                  updateStateOfPreJoinSettings={updateStateOfPreJoinSettings}
                  preJoinSettings={preJoinSettings}
                  onNameChange={(newName) => {
                    setDisplayNameUi(newName);
                    displayName = newName;
                  }}
                  dynamicMessage={dynamicMessage}
                />
              )
              : pagenumber == 3 ?
                <div className={`maindiv-calling`} ref={ToCaptureRef} >
                  <div className="videopart-main-div">
                    {/* <div className={`videoContainerGrid ${layoutClass()} ${isRightPanelOpen ? 'rightPanelOpen' : ''}`}>
                      {screenShareItem ? (
                        <ScreenSharingView
                          screenShareItem={screenShareItem}
                          participantItems={participantItems}
                          participantCount={participantCountGlobal}
                          pageIndex={pageIndex}
                          localDisplayName={displayNameUi}
                          isAudioOnGoingLocal={isAudioOngoingForLocal}
                          getInitials={getInitials}
                          unmute_incall={unmute_incall}
                          mute_incall={mute_incall}
                          localVideoStream={localVideoStream}
                          isVideoOnGoing={isVideoOnGoing}
                          isScreenSharing={isScreenSharing}
                          screenSharerUserId={screenSharerUserId}
                          userId={userId}
                          localParticipant={getLocalParticipantDetails()}
                        />
                      ) : (
                        <>
                          {displayRemoteParticipant && displayRemoteParticipant.map((item, index) => (
                            <RenderDynamicView key={item.userId} remoteVideoStream={item.stream} item={item} participantCount={participantCountGlobal} pageIndex={pageIndex} isScreenSharing={isScreenSharing} micOption={micOption} />
                          ))}
                          {!screenShareItem && pageIndex === 0 && (
                            <div className={getVideoClass(participantCount)}
                              ref={localVideoContainerRef}
                            >
                            </div>
                          )}
                        </>
                      )}
                    </div> */}
                    <div
                      className={
                        pinnedParticipantId
                          ? "videoContainerGrid"
                          : `videoContainerGrid ${layoutClass()} ${isRightPanelOpen ? "rightPanelOpen" : ""}`
                      }
                    >

                      {/* 1. If screen sharing is ON → screen share always has top priority */}
                      {screenShareItem ? (
                        <ScreenSharingView
                          screenShareItem={screenShareItem}
                          participantItems={participantItems}
                          participantCount={participantCountGlobal}
                          pageIndex={pageIndex}
                          localDisplayName={displayNameUi}
                          isAudioOnGoingLocal={isAudioOngoingForLocal}
                          getInitials={getInitials}
                          unmute_incall={unmute_incall}
                          mute_incall={mute_incall}
                          localVideoStream={localVideoStream}
                          isVideoOnGoing={isVideoOnGoing}
                          isScreenSharing={isScreenSharing}
                          screenSharerUserId={screenSharerUserId}
                          userId={userId}
                          localParticipant={getLocalParticipantDetails()}
                        />

                      ) : pinnedParticipantId ? (
                        /* 2. If someone is pinned → show PinnedParticipantView */
                        <PinnedParticipantView
                          pinnedParticipantId={pinnedParticipantId}
                          allParticipants={displayRemoteParticipant}
                          localVideoStream={localVideoStream}
                          isVideoOnGoing={isVideoOnGoing}
                          isAudioOnGoingLocal={isAudioOngoingForLocal}
                          unmute_incall={unmute_incall}
                          mute_incall={mute_incall}
                          localDisplayName={displayNameUi}
                          getInitials={getInitials}
                          userId={userId}
                          participantCount={participantCountGlobal}
                          pageIndex={pageIndex}
                          isDarkTheme={isDarkTheme}
                        />

                      ) : (
                        /* 3. Normal layout: No screen share and no pin */
                        <>
                          {displayRemoteParticipant &&
                            displayRemoteParticipant.map((item) => (
                              <RenderDynamicView
                                key={item.userId}
                                remoteVideoStream={item.stream}
                                item={item}
                                participantCount={participantCountGlobal}
                                pageIndex={pageIndex}
                                isScreenSharing={isScreenSharing}
                                micOption={micOption}
                              />
                            ))}

                          {/* Local video only on page 0 if no screen sharing */}
                          {!screenShareItem && pageIndex === 0 && (
                            <div
                              className={getVideoClass(participantCount)}
                              ref={localVideoContainerRef}
                            ></div>
                          )}
                        </>
                      )}
                    </div>

                    <DisplayParticipantComponent clientObjectArr={clientObjectArr} ref={modalRefParticipant} acsRoomId={acsRoomId} userId={userId} socket={socket} isCallCreator={isCallCreator.current[userId]} CbFromParticipant={CbFromParticipant} params={{ tokenFromAzureLogin: tokenFromAzureLogin, progressId: progressId }} updateCallCreator={updateCallCreator} updateStatusOnUiCB={updateStatusOnUiCB} dataCheck={isCallCreator} resendRecordingPermission={resendRecordingPermission} resendRecordingPermissionForDenied={resendRecordingPermissionForDenied} handlePinParticipant={handlePinParticipant} handleUnpinParticipant={handleUnpinParticipant} />
                    <DisplayScreenShot ref={modalRefScreenShot} acsRoomId={acsRoomId} userId={userId} socket={socket} isCallCreator={isCallCreator.current[userId]} CbFromParticipant={CbFromParticipant} isDarkTheme={isDarkTheme} />
                    <ACSChat
                      ref={modalChatRef}
                      userName={displayName}
                      roomId={acsRoomId}
                      userId={userId}
                      token={userAccessToken}
                      ownerToken={ownerToken}
                      clientObjectArr={clientObjectArr}
                      CbFromParticipant={CbFromParticipant}
                      CallBackFunctionForGetUnreadMessages={CallBackFunctionForGetUnreadMessages}
                      isDarkTheme={isDarkTheme}
                    />
                    <VisualEffectsPanel
                      ref={visualEffectsPanelRef}
                      CbFromParticipant={CbFromParticipant}
                      options={visualEffectsOptions}
                      selectedEffectId={selectedVisualEffect}
                      onSelectEffect={applyVisualEffect}
                      isApplying={isApplyingVisualEffect}
                      pendingEffectId={pendingVisualEffectId}
                      canApply={Boolean(localVideoStream && isVideoOnGoing)}
                      isDarkTheme={isDarkTheme}
                    />
                  </div>
                  {/* -------------page 3--end-------- */}
                  {call && <div className={`videopart-controlpart-main ${isRightPanelOpen ? 'withPanelOpen' : ''}`}>
                    <div className={`video-control-part`}>
                      {/* <span data-title="Camera">
                        <img src={isVideoOnGoing ? start_video : stop_video} alt="Description" onClick={() => clickOnVideoIcon()}
                          className='video-cotrol-btn-video' />
                      </span> */}
                      <AnimatedMicrophone
                        isAudioOnGoing={isAudioOnGoing}
                        // onMicToggle={clickOnMuteUnmuteIcon}
                        isEnabled={isAudioOnGoing}
                        showVolumeIndicator
                        size={28}
                      />
                      <div className='feature' style={{ position: 'relative' }}>
                        <div onClick={() => clickOnMuteUnmuteIcon()} style={{ display: 'flex', alignItems: 'center' }}>
                          <span data-title={isAudioOnGoing ? "Mute" : "Unmute"}>
                            <img src={isAudioOnGoing ? OnMicIcon : offMicIcon} alt='audio'
                              className='icon' />
                          </span>
                          <span className='sep'></span>
                        </div>
                        <div className="separator" style={{ width: '1px', height: '28px', backgroundColor: isDarkTheme ? '#23272E' : '#181C28', margin: '0 5px' }}></div>
                        <div className="arrow"
                          src={ArrowDownIcon}
                          onClick={toggleMicrophoneDropdown}
                          style={{ cursor: 'pointer', marginLeft: '5px' }}>
                          <img
                            src={ArrowDownIcon}
                          />
                        </div>
                        {microphoneDropdownOpen && (
                          <div className='menuList' style={{
                            position: 'absolute',
                            left: 0,
                            zIndex: 1000,
                            display: 'block',
                            marginTop: '5px'
                          }}>
                            <span className='title'>Microphone</span>
                            <div className='options'>
                              {/* <div className='item' style={{ fontSize: '10px', color: '#666' }}>
                                {availableAudioDevices.length} devices found
                              </div> */}
                              {audioError ? (
                                <div className='item' style={{ color: !isDarkTheme ? '#000' : '#fff', fontSize: '12px' }}>
                                  {audioError}
                                  {/* {audioError.includes('denied') && (
                                    <div
                                      className='item'
                                      style={{
                                        color: '#17B2FF',
                                        fontSize: '12px',
                                        cursor: 'pointer',
                                        // marginTop: '5px',
                                        bottom: '50px',
                                        textDecoration: 'underline'
                                      }}
                                      onClick={() => {
                                        clearAudioError();
                                        loadAudioDevices();
                                      }}
                                    >
                                      Click to retry
                                    </div>
                                  )} */}
                                </div>
                              ) : availableAudioDevices.length === 0 ? (
                                <div className='item' style={{ color: '#666', fontSize: '12px' }}>
                                  No microphone detected
                                </div>
                              ) : (
                                availableAudioDevices.map((device, index) => (
                                  <div
                                    key={device.deviceId || index}
                                    className={`item ${selectedAudioDevice?.deviceId === device.deviceId ? 'selected' : ''}`}
                                    onClick={() => {
                                      selectAudioDevice(device);
                                      switchAudioDevice(device);
                                      setMicrophoneDropdownOpen(false);
                                    }}
                                    style={{
                                      cursor: 'pointer',
                                      backgroundColor: selectedAudioDevice?.deviceId === device.deviceId
                                        ? (!isDarkTheme ? '#23272E' : 'rgba(0, 0, 0, 0.15)')
                                        : 'transparent',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      borderLeft: selectedAudioDevice?.deviceId === device.deviceId ? '3px solid #F25920' : 'none',
                                      paddingLeft: selectedAudioDevice?.deviceId === device.deviceId ? '9px' : '12px',
                                      fontWeight: selectedAudioDevice?.deviceId === device.deviceId ? '600' : '500',
                                      color: selectedAudioDevice?.deviceId === device.deviceId
                                        ? (isDarkTheme ? '#ffffff' : '#0094FF')
                                        : (isDarkTheme ? '#ffffff' : '#000000'),
                                      transition: 'all 0.2s ease'
                                    }}
                                  >
                                    <span style={{ fontSize: '12px', color: !isDarkTheme ? '#000' : '#fff' }}>
                                      {device.label || `Microphone ${index + 1}`}
                                    </span>
                                    {selectedAudioDevice?.deviceId === device.deviceId && (
                                      <span style={{ color: isDarkTheme ? '#000' : '#fff', fontSize: '14px' }}>✓</span>
                                    )}
                                  </div>
                                ))
                              )}
                            </div>
                            {/* <div className='item' style={{ borderTop: '1px solid #eee', marginTop: '5px', paddingTop: '5px' }}>
                              <img src={settingsIcon} alt='setting' className='menuIcon' />
                              Audio Settings
                            </div> */}
                          </div>
                        )}
                      </div>

                      <div className='feature' style={{ position: 'relative' }}>
                        <div onClick={() => clickOnVideoIcon()} style={{ display: 'flex', alignItems: 'center' }}>
                          <span data-title={isVideoOnGoing ? "Turn Off Camera" : "Turn On Camera"}>
                            <img src={isVideoOnGoing ? OnVideoIcon : OffVideoIcon}
                              className='icon' alt='video' />
                          </span>
                          <span className='sep'></span>
                        </div>
                        <div className="separator" style={{ width: '1px', height: '28px', backgroundColor: isDarkTheme ? '#23272E' : '#181C28', margin: '0 5px' }}></div>
                        <div
                          className='arrow'
                          onClick={toggleCameraDropdown}
                          style={{ cursor: 'pointer', marginLeft: '5px' }}>
                          <img
                            src={ArrowDownIcon}
                          />
                        </div>
                        {cameraDropdownOpen && (
                          <div className='menuList' style={{
                            position: 'absolute',
                            left: 0,
                            zIndex: 1000,
                            display: 'block',
                            marginTop: '5px'
                          }}>
                            <span className='title'>Camera</span>
                            <div className='options'>
                              {/* <div className='item' style={{ fontSize: '10px', color: '#666' }}>
                                {availableVideoDevices.length} cameras found
                              </div> */}
                              {videoError ? (
                                <div className='item' style={{ color: !isDarkTheme ? '#000' : '#fff', fontSize: '12px' }}>
                                  {videoError}
                                  {/* {videoError.includes('denied') && (
                                    <div
                                      className='item'
                                      style={{
                                        color: '#17B2FF',
                                        fontSize: '12px',
                                        cursor: 'pointer',
                                        // marginTop: '5px',
                                        bottom: '50px',
                                        textDecoration: 'underline'
                                      }}
                                      onClick={() => {
                                        clearVideoError();
                                        loadVideoDevices();
                                      }}
                                    >
                                      Click to retry
                                    </div>
                                  )} */}
                                </div>
                              ) : availableVideoDevices.length === 0 ? (
                                <div className='item' style={{ color: '#666', fontSize: '12px' }}>
                                  No camera detected
                                </div>
                              ) : (
                                availableVideoDevices.map((device, index) => (
                                  <div
                                    key={device.deviceId || index}
                                    className={`item ${selectedVideoDevice?.deviceId === device.deviceId ? 'selected' : ''}`}
                                    onClick={() => {
                                      // switchVideoDevice handles both UI state update and actual camera switch
                                      switchVideoDevice(device);
                                      setCameraDropdownOpen(false);
                                    }}
                                    style={{
                                      cursor: 'pointer',
                                      backgroundColor: selectedAudioDevice?.deviceId === device.deviceId
                                        ? (isDarkTheme ? '#23272E' : 'rgba(0, 0, 0, 0.15)')
                                        : 'transparent',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      borderLeft: selectedVideoDevice?.deviceId === device.deviceId ? '3px solid #F25920' : 'none',
                                      paddingLeft: selectedVideoDevice?.deviceId === device.deviceId ? '9px' : '12px',
                                      fontWeight: selectedVideoDevice?.deviceId === device.deviceId ? '600' : '500',
                                      color: selectedVideoDevice?.deviceId === device.deviceId
                                        ? (isDarkTheme ? '#ffffff' : '#0094FF')
                                        : (isDarkTheme ? '#ffffff' : '#000000'),
                                      transition: 'all 0.2s ease'
                                    }}
                                  >
                                    <span style={{ fontSize: '12px', color: !isDarkTheme ? '#000' : '#282D38' }}>
                                      {device.label || `Camera ${index + 1}`}
                                    </span>
                                    {selectedVideoCameraDevice === device.label && (
                                      <span style={{ color: isDarkTheme ? '#000' : '#17B2FF', fontSize: '14px' }}>✓</span>
                                    )}
                                  </div>
                                ))
                              )}
                            </div>
                            {/* <div className='item' style={{ borderTop: '1px solid #eee', marginTop: '5px', paddingTop: '5px' }}>
                              <img src={settingsIcon} alt='setting' className='menuIcon' />
                              Video Settings
                            </div> */}
                          </div>
                        )}
                      </div>
                      {/* ----------Audio--------- */}
                      {/* <span data-title={isAudioOnGoing ? "Mute" : "Unmute"}>
                        <AnimatedMicrophone 
                          isAudioOnGoing={isAudioOnGoing}
                          onMicToggle={clickOnMuteUnmuteIcon}
                          isEnabled={isAudioOnGoing}
                          showVolumeIndicator={true}
                        />
                      </span> */}

                      {/* Screen sharing button */}
                      {/* <span style={{ margin: '7px 0 5px 3px' }}>
                        {!isScreenSharing ? (
                          <MonitorUp
                            size={38}
                            onClick={() => {
                              if (isSomeoneScreenSharing()) {
                                requestScreenSharePermission();
                              } else {
                                startScreenSharing();
                              }
                            }}
                            style={{
                              cursor: pendingScreenShareRequest ? 'not-allowed' : 'pointer',
                              marginLeft: '5px',
                              opacity: pendingScreenShareRequest ? 0.5 : 1
                            }}
                            data-title={
                              pendingScreenShareRequest
                                ? "Screen share request pending..."
                                : isSomeoneScreenSharing()
                                  ? "Request Screen Share Permission"
                                  : "Start Screen Sharing"
                            }
                          />
                        ) : (
                          <MonitorX
                            size={38}
                            onClick={stopScreenSharing}
                            style={{ cursor: 'pointer', color: '#e74c3c', marginLeft: '5px' }}
                            data-title="Stop Screen Sharing"
                          />
                        )}
                      </span> */}

                      <div className='feature'
                        style={{
                          cursor: pendingScreenShareRequest ? 'not-allowed' : 'pointer',
                          opacity: pendingScreenShareRequest ? 0.5 : 1,
                          backgroundColor: isScreenSharing ? '#FF1D1D' : ''
                        }}
                        onClick={() => {
                          // Close all open menus
                          closeAllToggles();

                          if (!isScreenSharing) {
                            if (isSomeoneScreenSharing()) {
                              requestScreenSharePermission();
                            } else {
                              startScreenSharing();
                            }
                          } else {
                            stopScreenSharing();
                          }
                        }}>
                        <span data-title={isScreenSharing ? "Stop Screen Share" : "Screen Share"}>
                          <img src={ScreenShareIcon}
                            alt='screenshare'
                            className='icon' />
                        </span>
                      </div>

                      <div className='feature'>
                        <span data-title="Screenshot">
                          <img src={screenshotIcon} className='icon' alt='screenshot' onClick={toggleScreenShotMenuList} />
                        </span>
                        <div className={`menuList ${openScreenShotMenuList ? 'active' : ''}`}>
                          <div className='item' onClick={() => {
                            takeScreenShot({ uinfo, ToCaptureRef, tokenFromAzureLogin, toast, openAndRefreshList })
                            setOpenScreenShotMenuList(false);
                          }}>
                            <img src={screenshotIcon} alt='screenshot' className='menuIcon' />
                            Take Screenshot
                          </div>
                          <div className='item' onClick={() => {
                            openScreenShotPanel()
                            setOpenScreenShotMenuList(false);
                            infoToast.info('Fetching data, Please Wait...')
                            setTimeout(() => {
                              toast.dismiss()
                            }, 2000)
                          }}>
                            <img src={viewScreenShotIcon} alt='screenshot' className='menuIcon' />
                            View Screenshot
                          </div>
                        </div>
                      </div>


                      {/* <span data-title="End Call">
                      <img src={end_call} alt="Description" onClick={() => {
                        const checkMultipleAdmins = clientObjectArr.filter(item => item?.userType === 'Admin');
                        if (isCallCreator.current[userId]) {
                          console.log("Entering in end call")
                          isModalFor = 'EndCall'
                          // setIsRecordingModal(true)
                          if (checkMultipleAdmins.length > 1 && recordingStatus === 'starting') {
                            setRecordingTransferModel(true)
                          } else {
                            setIsRecordingModal(true)
                          }
                        } else {
                          clickOnDisconnectIconWithPiP('ClickOnDisconnect')
                          disconnectCall('ClickOnDisconnect')
                        }

                      }}
                        className='video-cotrol-btn' />
                    </span> */}

                      {/* ----------participant--------- */}
                      {/* <span data-title="Participants">
                        <img src={participant} alt="Description" onClick={async () => {
                          isChatPannelOpen = true;
                          openParticipantList();

                        }}
                          className='video-cotrol-btn' />
                      </span> */}

                      <div className='feature endCall' style={{ position: 'relative' }}>
                        <div
                          onClick={() => {
                            const checkMultipleAdmins = clientObjectArr.filter(item => item?.userType === 'Admin');
                            if (isCallCreator.current[userId]) {
                              isModalFor = 'EndCall'
                              setEndCallModalIntent(null);
                              if (checkMultipleAdmins.length > 1 && recordingStatus === 'starting') {
                                setRecordingTransferModel(true)
                              } else {
                                setIsRecordingModal(true)
                              }
                            } else {
                              clickOnDisconnectIcon('ClickOnDisconnect')
                              disconnectCall('ClickOnDisconnect')
                            }
                          }}
                          style={{ display: 'flex', alignItems: 'center' }}
                        >
                          <span data-title={isCallCreator.current[userId] ? "End Call" : "Disconnect Call"}>
                            <img src={telephoneIcon}
                              alt='hand'
                              className='icon' />
                          </span>
                        </div>
                        <div className="separator" style={{ width: '1px', height: '28px', backgroundColor: isDarkTheme ? '#23272E' : '#181C28', margin: '0 5px' }}></div>
                        <div
                          className='arrow'
                          onClick={toggleEndCallDropdown}
                          style={{ cursor: 'pointer', marginLeft: '5px', top: "-1px" }}
                        >
                          <img src={WhiteArrowDownIcon} alt='end options' />
                        </div>
                        {isEndCallDropdownOpen && (
                          <div
                            className='menuList end-call-menu'
                            style={{
                              position: 'absolute',
                              left: '50%',
                              transform: 'translateX(-50%)',
                              zIndex: 1000,
                              display: 'block',
                              marginTop: '5px',
                              backgroundColor: isDarkTheme ? '#1C1F2E' : '#FFFFFF',
                              boxShadow: isDarkTheme ? '0 12px 30px rgba(0,0,0,0.6)' : '0 8px 24px rgba(15,23,42,0.15)'
                            }}
                          >
                            <div
                              className='item'
                              onClick={handleLeaveMeetingSelection}
                              style={{
                                color: isDarkTheme ? '#FFFFFF' : '#111827',
                                fontSize: '12px',
                                fontWeight: 500
                              }}
                            >
                              Leave Meeting
                            </div>
                            {isCallCreator.current[userId] && (
                              <div
                                className='item'
                                onClick={handleEndMeetingSelection}
                                style={{
                                  color: '#F25920',
                                  fontSize: '12px',
                                  fontWeight: 600
                                }}
                              >
                                End Meeting
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      <div className={`feature ${riseHandActiveStatus ? 'raiseHandActive' : ''} ${isRiseHandLoading ? 'loading' : ''}`} onClick={() => clickOnRiseHandIcon()}
                        style={{
                          backgroundColor: riseHandActiveStatus ? '#F25920' : ''
                        }}
                      >
                        <span data-title={riseHandActiveStatus ? "Lower Hand" : "Raise Hand"}>
                          {isRiseHandLoading ? (
                            <div className="loading-spinner" style={{
                              width: '20px',
                              height: '20px',
                              border: '2px solid #fff',
                              borderTop: '2px solid transparent',
                              borderRadius: '50%',
                              animation: 'spin 1s linear infinite'
                            }} />
                          ) : (
                            <img src={handRaiseIcon}
                              alt='hand'
                              className='icon' />
                          )}
                        </span>
                      </div>

                      <div className='feature' onClick={async () => {
                        // Close all open menus
                        closeAllToggles();

                        isChatPannelOpen = true;
                        openParticipantList();
                      }}>
                        <span data-title="Participants">
                          <img src={participantIcon}
                            alt='participant'
                            className='icon' />
                        </span>
                        <span className='count'>{totalParticipantCount}</span>
                      </div>

                      {/* <span data-title="Raise Hand">
                        <img src={riseHandActiveStatus ? raise_hand_active : rise_hand} alt="Description" onClick={() => clickOnRiseHandIcon()}
                          className='video-cotrol-btn' />
                      </span> */}

                      {/*----------Chat Component--------*/}
                      {/* <button
                        onClick={async () => {
                          isChatPannelOpen = true;
                          openChatPanel();

                        }}
                        className="chat-toggle-button"
                        data-title="Chat"
                      >
                        <ChatIconSVG />
                        {isChatPannelOpen === false && totalUnreadMessageCount > 0 && <span className="chat-badge">{totalUnreadMessageCount}</span>}
                      </button> */}

                      <div className='feature' onClick={async () => {
                        // Close all open menus
                        closeAllToggles();

                        isChatPannelOpen = true;
                        openChatPanel();
                      }}>
                        <span data-title="Chat">
                          <img src={chatIcon}
                            alt='chat'
                            className='icon' />
                        </span>
                        {isChatPannelOpen === false && totalUnreadMessageCount > 0 &&
                          <span className="message-count">{totalUnreadMessageCount}</span>}
                      </div>

                      <div className='feature' onClick={toggleMenuList}>
                        <span data-title="More Options">
                          <img src={ellipsisYIcon} alt='ellipsis' className='icon' />
                        </span>
                        <div className={`menuList ${isMenuListOpen ? "active" : ""}`}>
                          {/* Show Start Recording button for admins */}
                          {isCallCreator.current[userId] && recordingInitiatorId !== userId && (
                            <div
                              className={`item ${(recordingStatus !== 'initial' || isRecordingConsentRequested) ? 'disabled' : ''}`}
                              onClick={() => {
                                if (recordingStatus === 'initial' && !isRecordingConsentRequested) {
                                  openParticipantListForRecording();
                                  setIsMenuListOpen(false);
                                }
                              }}
                              title={(recordingStatus !== 'initial' || isRecordingConsentRequested) ? 'Recording consent is being requested or recording is already in progress' : 'Start Recording'}
                            >
                              <img src={recordingIcon} alt='recording' className='menuIcon' />
                              Start Recording
                            </div>
                          )}
                          {/* Show Stop Recording button for the recording initiator */}
                          {isCallCreator.current[userId] && recordingInitiatorId === userId && recordingStatus === 'starting' && (
                            <>
                              {/* <div className='item' onClick={async () => {
                                let pauseObj = await pauseRecording()
                                console.log('----pauseObj----', pauseObj)
                                if (pauseObj?.recordingId) {
                                  setRecordingStatus('paused');
                                  socket.emit('BE-update-status', { acsRoomId: acsRoomId, senderUserId: userId, socketId: socket.id, data: { isSuccessMsg: false, status: 'RecordingPaused' }, type: 'BroadCastMessage', typeValue: 'Recording Paused' });
                                  modalRefParticipant.current.updateRecordingFlag('paused');
                                }
                              }}>
                                <img src={pauseRecordingIcon} alt='pause recording' className='menuIcon' />
                                Pause Recording
                              </div> */}
                              <div className='item' onClick={() => {
                                handleStopRecordingClick();
                                setIsMenuListOpen(false);
                              }}>
                                <img src={stopRecordingIcon} alt='stop recording' className='menuIcon' />
                                Stop Recording
                              </div>
                            </>
                          )}
                          {/* Show Stop Recording button when paused (for the recording initiator) */}
                          {isCallCreator.current[userId] && recordingInitiatorId === userId && recordingStatus === 'paused' && (
                            <>
                              {/* <div className='item' onClick={async () => {
                                let resumeObj = await ResumeRecording()
                                console.log('----resumeObj----', resumeObj)
                                if (resumeObj?.recordingId) {
                                  setRecordingStatus('starting');
                                  socket.emit('BE-update-status', { acsRoomId: acsRoomId, senderUserId: userId, socketId: socket.id, data: { isSuccessMsg: true, status: 'RecordingResume' }, type: 'BroadCastMessage', typeValue: 'Recording Resumed' });
                                  modalRefParticipant.current.updateRecordingFlag('started');
                                }
                              }}>
                                <img src={resumeRecordingIcon} alt='resume recording' className='menuIcon' />
                                Resume Recording
                              </div> */}
                              <div className='item' onClick={() => {
                                handleStopRecordingClick();
                                setIsMenuListOpen(false);
                              }}>
                                <img src={stopRecordingIcon} alt='stop recording' className='menuIcon' />
                                Stop Recording
                              </div>
                            </>
                          )}
                          <div
                            className={`item ${!isPiPSupported ? 'disabled' : ''} ${isPiPActive ? 'active' : ''}`}
                            onClick={isPiPSupported ? () => {
                              handlePiPToggle();
                              setIsMenuListOpen(false);
                            } : undefined}
                            style={{
                              cursor: isPiPSupported ? 'pointer' : 'not-allowed',
                              opacity: isPiPSupported ? 1 : 0.5,
                              backgroundColor: isPiPActive ? 'rgba(0, 123, 255, 0.1)' : 'transparent'
                            }}
                            title={
                              !isPiPSupported
                                ? 'PiP not supported in this browser'
                                : isPiPActive
                                  ? 'Exit Picture-in-Picture'
                                  : 'Enter Picture-in-Picture'
                            }
                          >
                            <img src={PIPIcon} alt='pip' className='menuIcon' />
                            {isPiPActive ? 'Exit PIP' : 'Toggle PIP'}
                            {isPiPLoading && <span className="pip-loading-indicator">⏳</span>}
                          </div>
                          {/* <div className='item'>
                            <img src={permissionIcon} alt='permission' className='menuIcon' />
                            Permission
                          </div> */}
                          {/* <div className='item'>
                            <img src={reportIcon} alt='report' className='menuIcon' />
                            Report an Issue
                          </div> */}
                          <div
                            className={`item ${isVisualEffectsPanelOpenState ? 'active' : ''}`}
                            onClick={() => {
                              openVisualEffectsPanel();
                              setIsMenuListOpen(false);
                            }}
                          >
                            <Wand className='menuIcon' />
                            Visual Effects
                          </div>
                          <div className='item' onClick={() => {
                            setIsNetworkDiagnosticModalOpen(true);
                            setIsMenuListOpen(false);
                          }}>
                            <img src={troubleshootIcon} alt='troubleshoot' className='menuIcon' />
                            Troubleshoot
                          </div>
                          <div className='item' onClick={() => {
                            setIsSettingsModalOpen(true);
                            setIsMenuListOpen(false);
                          }}>
                            <img src={settingsIcon} alt='settings' className='menuIcon' />
                            Settings
                          </div>
                        </div>
                      </div>

                      <div className='feature' onClick={toggleTheme}>
                        <span data-title="Theme">
                          <img src={bulbIcon} alt='bulb' className='icon' />
                        </span>
                        <div className={`menuList ${isThemeOpen ? "active" : ""}`}>
                          <div className='item' onClick={switchToLightTheme}>
                            <img src={lightThemeIcon} alt='light' className='menuIcon' />
                            Light
                            {!isDarkTheme && <span style={{ marginLeft: 'auto', color: '#4dabf7' }}>✓</span>}
                          </div>
                          <div className='item' onClick={switchToDarkTheme}>
                            <img src={darkThemeIcon} alt='dark' className='menuIcon' />
                            Dark
                            {isDarkTheme && <span style={{ marginLeft: 'auto', color: '#4dabf7' }}>✓</span>}
                          </div>
                        </div>
                      </div>

                      {/* {renderRecordingButton()} */}
                      {/* ------status showing for other users------ */}
                      {/* {renderRecordingStatusIndicator()}
                      {renderStopRecordingButton()} */}
                      {/* ----------prev--------- */}
                      {/* {renderScreenshotDropdown()} */}
                      {/* ----------end call--------- */}

                      {isShowPaggination ? (
                        <div className="modern-pagination">
                          <button
                            className={`pagination-btn prev-btn ${pageIndex === 0 ? 'disabled' : ''}`}
                            onClick={() => prevPaggination()}
                            disabled={pageIndex === 0}
                            title="Previous page"
                          >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>

                          <div className="pagination-info">
                            <span className="page-indicator">
                              Page {pageIndex + 1}
                            </span>
                            <span className="participant-count">
                              {totalParticipantCount} participants
                            </span>
                          </div>

                          <button
                            className={`pagination-btn next-btn ${!isNextBtnActive ? 'disabled' : ''}`}
                            onClick={() => nextPaggination()}
                            disabled={!isNextBtnActive}
                            title="Next page"
                          >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>
                        </div>
                      ) : null}
                    </div>
                    {recordingStatus !== 'initial' && (
                      <div className='recording-indicator' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <span className='timer'>{recordingStatus === 'paused' ? 'PAUSED' : 'REC'}</span>
                        <span className='recording-timer' style={{ color: !isDarkTheme ? '#000' : '#fff' }}>{recordingTimer}</span>
                      </div>
                    )}
                  </div>}


                  {/* <p style={{ position: 'absolute', fontSize: 14, color: '#000', left: 15, bottom: 7 }}>{callDuration}</p> */}
                  {/* <Timer initialSeconds={callDurationInSec} /> */}
                  <ReactInternetSpeedMeter
                    // txtSubHeading="Internet is too slow"
                    // outputType="alert"
                    // customClassName={null}
                    // txtMainHeading="Opps..." 
                    pingInterval={60000} // milliseconds 
                    thresholdUnit='megabyte' // "byte" , "kilobyte", "megabyte" 
                    threshold={5}
                    imageUrl="https://farm2.staticflickr.com/1533/26541536141_41abe98db3_z_d.jpg"
                    downloadSize="1781287"  //bytes
                    // callbackFunctionOnNetworkDown={(speed)=>console.log(`Internet -------11- ${speed}`)}
                    callbackFunctionOnNetworkTest={(speed) => {
                      //console.log(`Internet --------- ${speed}`)
                      if (speed < 2) {
                        errorToast.error('Your internet connection is slow');
                      }
                    }}
                  />
                </div>
                :
                <div style={{
                  display: 'flex', flex: 1, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100vh', background: "#121417"
                }}>
                  {isRejoining ? (
                    // Show loader while rejoining
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '20px' }}>
                      <Loader />
                      <h3 style={{ color: "#F25920", marginTop: '20px' }}>Preparing to rejoin...</h3>
                      <p style={{ color: "#888", fontSize: '14px' }}>Please wait while we reset your session</p>
                    </div>
                  ) : (
                    // Show disconnect message and rejoin button
                    <>
                      <h1 style={{ marginTop: '7%', color: "#F25920" }}>{disconnectMessage}</h1>
                      {
                        rejoinBtnShowStatus ? <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                          <h4 style={{ color: "#F25920" }}>Do you want to rejoin the call?</h4>

                          <img
                            src={rejoin}
                            alt="Description"
                            onClick={handleRejoinCall}
                            style={{
                              width: 140,
                              resizeMode: 'contain',
                              cursor: rejoiningRef.current ? 'not-allowed' : 'pointer',
                              marginTop: 20,
                              opacity: rejoiningRef.current ? 0.5 : 1
                            }} />
                        </div> : null
                      }
                    </>
                  )}


                </div>
        }
      </div>

      <RequestedModal
        isOpen={isRequestedModalOpen}
        requestedAccessName={requestedAccessName}
        requesterName={requesterName}
        displayName={displayName}
        adminId={adminId}
        acsRoomId={acsRoomId}
        senderSocketIdGlobal={senderSocketIdGlobal}
        socket={socket}
        clickOnVideoIcon={clickOnVideoIcon}
        clickOnMuteUnmuteIcon={clickOnMuteUnmuteIcon}
        setIsRequestedModalOpen={setIsRequestedModalOpen}
        setRequestedAccessName={setRequestedAccessName}
      />

      <ScreenSharePermissionModal
        isOpen={isScreenSharePermissionModalOpen}
        requestingUser={screenShareRequestData?.requestingUser}
        currentScreenSharer={screenShareRequestData?.currentScreenSharer}
        onAccept={() => {
          // Approve the screen share request
          const currentScreenSharer = getCurrentScreenSharer();

          // Force stop current screen share if exists
          if (currentScreenSharer) {
            socket.emit('BE-update-status', {
              acsRoomId,
              senderUserId: userId,
              socketId: socket.id,
              data: {
                requestId: screenShareRequestData.requestId,
                currentScreenSharerId: currentScreenSharer.userId,
                approved: true,
                adminId: userId,
                adminName: displayName
              },
              type: 'ForceStopScreenShare'
            });
          }

          // Send approval response with a slight delay to ensure current screen share is stopped first
          setTimeout(() => {
            socket.emit('BE-update-status', {
              acsRoomId,
              senderUserId: screenShareRequestData.requestingUser.userId,
              socketId: screenShareRequestData.requestingUser.socketId,
              data: {
                requestId: screenShareRequestData.requestId,
                approved: true,
                adminId: userId,
                adminName: displayName
              },
              type: 'ScreenSharePermissionResponse'
            });
          }, 500); // 500ms delay to ensure current screen share is stopped

          setIsScreenSharePermissionModalOpen(false);
          setScreenShareRequestData(null);
        }}
        onDeny={() => {
          // Deny the screen share request
          socket.emit('BE-update-status', {
            acsRoomId,
            senderUserId: screenShareRequestData.requestingUser.userId,
            socketId: screenShareRequestData.requestingUser.socketId,
            data: {
              requestId: screenShareRequestData.requestId,
              approved: false,
              adminId: userId,
              adminName: displayName
            },
            type: 'ScreenSharePermissionResponse'
          });

          setIsScreenSharePermissionModalOpen(false);
          setScreenShareRequestData(null);
        }}
        onClose={() => {
          setIsScreenSharePermissionModalOpen(false);
          setScreenShareRequestData(null);
        }}
      />

      <RecordingTransferModal
        isOpen={recordingTransferModel}
        setRecordingTransferModel={setRecordingTransferModel}
        setAdminListModel={setAdminListModel}
        setIsRecordingModal={setIsRecordingModal}
      />

      <AdminListModal
        isOpen={adminListModel}
        clientObjectArr={clientObjectArr}
        userId={userId}
        acsRoomId={acsRoomId}
        socket={socket}
        senderSocketIdGlobal={senderSocketIdGlobal}
        setAdminListModel={setAdminListModel}
        setRecordingTransferModel={setRecordingTransferModel}
        setRecordingStatus={setRecordingStatus}
        openParticipantListForRecording={openParticipantListForRecording}
        setIsRecordingModal={setIsRecordingModal}
      />

      <RecordingModal
        isOpen={isRecordingModal}
        isModalFor={isModalFor}
        endCallModalIntent={endCallModalIntent}
        clearEndCallModalIntent={clearEndCallModalIntent}
        clientObjectArr={clientObjectArr}
        userId={userId}
        displayName={displayName}
        acsRoomId={acsRoomId}
        senderUserIdGlobal={senderUserIdGlobal}
        senderSocketIdGlobal={senderSocketIdGlobal}
        socket={socket}
        setIsRecordingModal={setIsRecordingModal}
        setIsAlreadyJoined={setIsAlreadyJoined}
        clickOnDisconnectIcon={clickOnDisconnectIcon}
        disconnectCall={disconnectCall}
        startCallOnClick={startCallOnClick}
        stopRecording={stopRecording}
        setRecordingStatus={setRecordingStatus}
        setRecordingInitiatorId={setRecordingInitiatorId}
        setIsRecordingConsentRequested={setIsRecordingConsentRequested}
        modalRefParticipant={modalRefParticipant}
        recordingToast={recordingToast}
      />

      <PermissionErrorModal
        isOpen={permissionErrorModal.isOpen}
        deviceType={permissionErrorModal.deviceType}
        onClose={() => {
          setPermissionErrorModal({ isOpen: false, deviceType: null });
          if (permissionErrorModal.deviceType === 'camera') {
            setIsVideoOnGoing(false);
            videoOption = false;
          } else if (permissionErrorModal.deviceType === 'microphone') {
            setIsAudioOnGoing(false);
            micOption = false;
            if (call) {
              call.mute().catch(err => console.error("Can't mute:", err));
            }
          }
        }}
      />

      <NetworkDiagnosticModal
        isOpen={isNetworkDiagnosticModalOpen}
        onClose={() => setIsNetworkDiagnosticModalOpen(false)}
        autoStartTest="speed"
      />

      <SettingsModal
        isOpen={isSettingsModalOpen}
        onClose={() => setIsSettingsModalOpen(false)}
        settings={appSettings}
        onSettingsChange={handleSettingsChange}
        onMicrophoneChange={handleMicrophoneChange}
        onSpeakerChange={handleSpeakerChange}
        availableAudioDevices={availableAudioDevices}
        availableVideoDevices={availableVideoDevices}
        selectedAudioDevice={selectedAudioDevice}
        selectedVideoDevice={selectedVideoDevice}
      />

      {isLanguageModal ? <LanguageDropdown onSelectLanguage={onSelectLanguage} /> : null}
    </div>
  );
});

export default Home;
